// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT_PROFILE: `ملف الحساب`,
    ACCOUNT_CREATED: ``,
    ACCOUNT_VERIFIED: ``,
    LOG_IN_TO_START_ORDERING: ``,
    ORDERS: ``,
    PROFILE: ``,
    PROFILE_UPDATED: ``,
    PAYMENT_METHODS: ``,
    PERSONAL_DETAILS: ``,
    SAVE_CHANGES: ``,
    ADA_TOGGLE_ON: `اضغط لتفعيل خفض ارتفاع الشاشة`,
    ADA_TOGGLE_OFF: `اضغط لإلغاء تفعيل خفض ارتفاع الشاشة`,
    ADD: `إضافة`,
    ADD_DONATION: `إضافة تبرع`,
    ADD_FUNDS: `إضافة رصيد`,
    ADD_TIP: `إضافة إكرامية`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `إضافة إلى الطلب`,
    ADD_NEW: `إضافة جديد`,
    ADDED: `تمت الإضافة`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `تمت الإضافة إلى الطلب`,
    ADDON_TEXTFIELD_PLACEHOLDER: `اكتب اختيارك.`,
    ADDRESS_CITY: `المدينة`,
    ADDRESS_LINE_1: `العنوان`,
    ADDRESS_LINE_2: `شقة، طابق، جناح، مبنى، شركة (اختياري)`,
    ADDRESS_POSTAL_CODE: `الرمز البريدي`,
    ALCOHOL_VERIFICATION: `التحقق من الكحول`,
    ALREADY_HAVE_AN_ACCOUNT: ``,
    ALSO_CONSIDER: `قد يعجبك أيضًا`,
    APPLIED_STORED_VALUE_CARDS: `بطاقات الهدايا`,
    ASAP: `في أقرب وقت ممكن`,
    AT_LEAST_X: `{{$1: number}} على الأقل`,
    BACK: `رجوع`,
    BACK_TO_MENU: `العودة إلى القائمة`,
    BACK_TO_MENU_FROM_LOYALTY: `العودة إلى القائمة`,
    BACK_TO_CART: `العودة إلى السلة`,
    BACK_TO_PAYMENT_OPTIONS: `العودة إلى خيارات الدفع`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `العودة إلى خيارات الدفع`,
    BAD_ACCESS_CODE: `رمز الوصول غير صحيح`,
    BALANCE: `الرصيد`,
    BAG_OPT_IN_PROMPT: `هل ترغب في إضافة كيس سفري إلى طلبك؟`,
    BAG_OPT_IN_TITLE: `إضافة كيس؟`,
    BAG_OPT_IN: `نعم، أريد كيسًا`,
    BAG_OPT_OUT: `لا، شكرًا`,
    BLOCKED_WORD_WARNING: `يرجى إزالة الكلمات المحظورة`,
    CALORIES: `السعرات الحرارية`,
    CANCEL: `إلغاء`,
    CANCEL_CHECKOUT: `إلغاء`,
    CASH: `أمين الصندوق`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `بطاقة مسجّلة`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `بدون تلامس`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `مُدخلة يدويًا`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `مقدَّمة خارجيًا`,
    CARD_ENTRY_SCAN: `مسح`,
    CARD_ENTRY_SWIPE: `تمرير`,
    CARD_ENTRY_UNKNOWN: `غير معروف`,
    CARD_EXPIRED: `انتهت صلاحية بطاقتك`,
    CARD_EXPIRING: `ستنتهي صلاحية بطاقتك قريبًا`,
    CART: `السلة`,
    CART_LABEL: `الانتقال إلى السلة التي تضم {{$1: number}} صنفًا بقيمة {{$2: price}}`,
    CART_TITLE: ``,
    CHANGE_ITEM: `تغيير الصنف`,
    CHANGE_PASSWORD: `تغيير كلمة المرور`,
    CHANGE_PASSWORD_SUCCESS: `تم تحديث كلمة المرور الخاصة بك.`,
    CHARS_LEFT: `{{$1: number}} حرفًا متبقيًا`,
    CHECK_AMOUNT: `جارٍ التحقق من المبلغ...`,
    CHECKOUT: `الدفع`,
    CHECKOUT_STEP_CART: `السلة`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `الدفع`,
    CHECKOUT_STEP_PAYING: `جارٍ الدفع`,
    CHECKOUT_STEP_DONE: `تم`,
    CHECKOUT_WITH_FORCED_MENU: `لا يمكن الدفع أثناء عرض معاينة القائمة. الدفع متاح فقط في القائمة "المعروضة حاليًا".`,
    CHECK_YOUR_EMAIL: ``,
    CHOOSE_OPTION: `اختر خيارًا`,
    CHOOSE_TIME_SLOT: `يرجى اختيار موعد:`,
    CLEAR_ALL: `مسح الكل`,
    CLEARING_SESSION: `جارٍ تحضير الجهاز للضيف التالي...`,
    CLOSE: `إغلاق`,
    CLOSED_SCREEN_MESSAGE: `نعتذر، نحن مغلقون أو لا نقبل الطلبات عبر الجوال.`,
    CONFIRM: `تأكيد`,
    CONFIRM_ADDRESS: `تأكيد العنوان`,
    CONFIRM_DISCARD: `هل أنت متأكد أنك تريد تجاهل هذا الصنف؟`,
    CONFIRM_DISCARD_CHANGES: `هل أنت متأكد أنك تريد تجاهل تغييراتك؟`,
    CONFIRM_YOUR_ITEM: `أكّد صنفك`,
    CONFIRM_QUIT: `هل أنت متأكد أنك تريد الخروج؟`,
    CONFIRM_REFUND_AMOUNT: `هل أنت متأكد أنك تريد استرداد {{$1: dollar amount}} من هذه المعاملة؟`,
    CONFIRMING_YOUR_CARD: `جارٍ تأكيد بطاقتك...`,
    CONTINUE: `متابعة`,
    CONTINUE_AS_GUEST: `المتابعة كضيف`,
    COULD_WE_INTEREST: `ربما يعجبك...`,
    COMP_CARD: `بطاقة المجاملة`,
    COMP_CARD_SCAN: `امسح بطاقة المجاملة`,
    COMP_CARD_SCAN_FAILED_TITLE: `فشل مسح بطاقة المجاملة`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `حدث خطأ أثناء مسح بطاقة المجاملة. يرجى المحاولة مرة أخرى.`,
    COMP_CARD_APPLYING_TITLE: `جارٍ تطبيق بطاقة المجاملة`,
    COMP_CARD_APPLYING_ERROR_TITLE: `خطأ في تطبيق بطاقة المجاملة`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `حدث خطأ أثناء تطبيق بطاقة المجاملة. يرجى المحاولة مرة أخرى.`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `يرجى إدخال رقم بطاقة المجاملة`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `يرجى إدخال رقم صالح لبطاقة المجاملة`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `يرجى إدخال رقم صالح لبطاقة المجاملة`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `يرجى إدخال رمز PIN لبطاقة المجاملة`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `يرجى إدخال رمز PIN صالح لبطاقة المجاملة`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `يرجى إدخال رمز PIN صالح لبطاقة المجاملة`,
    COMP_CARD_ENTERING_NUMBER_HINT: `أدخل رقم بطاقة المجاملة. يمكن أن تتكون الأرقام من {{$1: number}} خانة.`,
    COMP_CARD_ENTERING_PIN_HINT: `أدخل رمز PIN لبطاقة المجاملة. يمكن أن تتكون الأرقام من {{$1: length}} خانة.`,
    COMP_CARD_ERROR_REMOVING: `حدث خطأ أثناء إزالة بطاقة المجاملة. يرجى المحاولة مرة أخرى.`,
    'bottom-bar.storm-toggle.on': `اضغط لتفعيل تنقّل Storm`,
    'bottom-bar.storm-toggle.off': `اضغط لإلغاء تفعيل تنقّل Storm`,
    'campus-card.label': `بطاقة الحرم الجامعي`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `اضغط للدفع ببطاقة الحرم الجامعي`,
    'campus-card.scan': `امسح بطاقة الحرم الجامعي`,
    'campus-card.scan-failed.title': `فشل مسح بطاقة الحرم الجامعي`,
    'campus-card.scan-failed.message': `حدث خطأ أثناء مسح بطاقة الحرم الجامعي. يرجى المحاولة مرة أخرى.`,
    'campus-card.enter-number': `أدخل رقم بطاقة الحرم الجامعي`,
    'campus-card.enter-pin': `أدخل رمز PIN لبطاقة الحرم الجامعي`,
    'campus-card.applying.title': `جارٍ تطبيق بطاقة الحرم الجامعي`,
    'campus-card.applying.error.title': `خطأ في تطبيق بطاقة الحرم الجامعي`,
    'campus-card.applying.error.message': `حدث خطأ أثناء تطبيق بطاقة الحرم الجامعي. يرجى المحاولة مرة أخرى.`,
    'campus-card.entering-number.error.required': `يرجى إدخال رقم بطاقة الحرم الجامعي`,
    'campus-card.entering-number.error.invalid': `يرجى إدخال رقم صالح لبطاقة الحرم الجامعي`,
    'campus-card.entering-number.error.length': `يرجى إدخال رقم صالح لبطاقة الحرم الجامعي`,
    'campus-card.entering-number.hint': `أدخل رقم بطاقة الحرم الجامعي. يمكن أن تتكون الأرقام من {{$1: number}} خانة.`,
    'campus-card.entering-pin.error.required': `يرجى إدخال رمز PIN لبطاقة الحرم الجامعي`,
    'campus-card.entering-pin.error.invalid': `يرجى إدخال رمز PIN صالح لبطاقة الحرم الجامعي`,
    'campus-card.entering-pin.error.length': `يرجى إدخال رمز PIN صالح لبطاقة الحرم الجامعي`,
    'campus-card.entering-pin.hint': `أدخل رمز PIN لبطاقة الحرم الجامعي. يمكن أن تتكون الأرقام من {{$1: length}} خانة.`,
    'campus-card.error-removing': `حدث خطأ أثناء إزالة بطاقة الحرم الجامعي. يرجى المحاولة مرة أخرى.`,
    'campus-card.no-balance.title': `لا يوجد رصيد متاح`,
    'campus-card.no-balance.message': `لا يوجد رصيد متاح في بطاقة الحرم الجامعي هذه.`,
    'campus-card.add-another': `إضافة أخرى`,
    'campus-card.remove': `إزالة بطاقة الحرم الجامعي`,
    'campus-card.select-account.title': `اختر حسابًا`,
    'campus-card.select-account.loading': `جارٍ تحميل الحسابات...`,
    'campus-card.select-account.error.title': `تعذّر تحميل الحسابات`,
    'campus-card.select-account.error.message': `لم نتمكن من تحميل حساباتك. يرجى المحاولة مرة أخرى.`,
    'campus-card.select-account.column.account': `الحساب`,
    'campus-card.select-account.column.balance': `الرصيد الحالي`,
    'campus-card.select-account.error.toast-title': `خطأ`,
    'campus-card.select-account.error.toast-message': `فشل التحقق. يرجى المحاولة مرة أخرى.`,
    'campus-card.swipe': `مرّر بطاقة الحرم الجامعي للدفع`,
    COUPON: `قسيمة`,
    COUPON_ALREADY_USED: `تم استخدام رمز القسيمة من قبل.`,
    COUPON_MIN_SPEND_NOT_MET: `رمز القسيمة الذي أدخلته لا يستوفي الحد الأدنى للإنفاق.`,
    COUPON_NOT_FOUND: `لم يتم العثور على رمز القسيمة.`,
    COUPON_NOT_ACCEPTED: `لم يتم قبول رمز القسيمة الذي أدخلته.`,
    COUPON_APPLYING: `جارٍ تطبيق القسيمة`,
    COUPON_APPLYING_ERROR_TITLE: `خطأ في تطبيق القسيمة`,
    COUPON_APPLYING_ERROR_MESSAGE: `حدث خطأ أثناء تطبيق القسيمة. يرجى المحاولة مرة أخرى.`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `رمز القسيمة الذي أدخلته لا يستوفي متطلبات الطلب.`,
    COUPON_SCANNING_ERROR_TITLE: `خطأ في مسح القسيمة`,
    COUPON_SCANNING_ERROR_MESSAGE: `حدث خطأ أثناء مسح القسيمة. يرجى المحاولة مرة أخرى.`,
    COUPON_ENTERING_ERROR_LENGTH: `يرجى إدخال رمز القسيمة.`,
    COUPON_ENTERING_ERROR_INVALID: `يرجى إدخال رمز قسيمة صالح.`,
    COUPON_ERROR_REMOVING: `حدث خطأ أثناء إزالة القسيمة. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى التواصل مع أحد الموظفين.`,
    CREATE_A_NEW_ACCOUNT: `إنشاء حساب جديد`,
    CREATE_ACCOUNT: `إنشاء حساب`,
    CREATE_ACCOUNT_TERMS_LINE: `بإنشاء حساب فإنك توافق على`,
    CREDIT_CARD: `بطاقة ائتمان`,
    CREDIT_CARD_NUMBER: `رقم البطاقة`,
    CURBSIDE: `الاستلام من الرصيف`,
    CURRENT_PASSWORD: `كلمة المرور الحالية`,
    CUSTOM_TIP: `مخصصة`,
    CUSTOM_TIP_INVALID: `يرجى إدخال مبلغ إكرامية صالح.`,
    CUSTOM_TIP_HINT: `أدخل مبلغ الإكرامية. الحد الأقصى: {{$1: number}}`,
    CUSTOM_DONATION: `تبرع مخصص`,
    CUSTOMER_CARDS: `استخدام بطاقة محفوظة`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `تسجيل الدخول`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `حسابك`,
    CUSTOMIZE: `تخصيص`,
    DEBIT: `خصم`,
    DEBIT_CREDIT_CARD: `بطاقة خصم/ائتمان`,
    DEMO_PAY: `Demo: الدفع`,
    DELIVERY: `التوصيل`,
    DELIVERY_ADDRESS: `عنوان التوصيل`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `إزالة {{$1: mod name}}`,
    DINE_IN: `تناول في المطعم`,
    DISCLAIMER_EMAIL: `يخضع استخدام البريد الإلكتروني لشروط الخدمة.`,
    DISCLAIMER_PHONE: `يخضع استخدام رقم الهاتف لشروط الخدمة.`,
    DISCLAIMER_PHONE_LINK: `شروط الخدمة:`,
    DISCLAIMER_PHONE_DESCRIPTION: `لاستخدام رقم الهاتف`,
    DISCLAIMER_NAME: `سيُستخدم اسمك لتأكيد طلبك وتسهيل استلامه من المنطقة المخصصة.`,
    DISCOUNTS: `الخصومات`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `سيتم تطبيق الخصومات عند الدفع`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `سيتم تطبيق الخصم عند الدفع`,
    DONATION: `تبرع`,
    DONATION_APPLYING: `جارٍ تطبيق التبرع...`,
    DONATION_APPLY_ERROR_TITLE: `خطأ في تطبيق التبرع`,
    DONATION_APPLY_ERROR_MESSAGE: `حدث خطأ أثناء تطبيق تبرعك. يرجى المحاولة مرة أخرى.`,
    DONATION_FAILED: `فشل التبرع. يرجى المحاولة مرة أخرى.`,
    DONATION_ROUND_UP_TITLE: `هل ترغب في تقريب إجمالي طلبك؟`,
    DONATION_ROUND_UP_TO: `التقريب إلى {{$1: amount}}`,
    DONATION_ROUND_UP_SUBTITLE: `هل ترغب في تقريب إجمالي طلبك إلى أقرب دولار كامل؟`,
    DONATION_ROUND_UP_ACCEPT: `نعم، قرّب المبلغ`,
    DONATION_ROUND_UP_REJECT: `لا، شكرًا`,
    DONATION_REMOVE: `إزالة التبرع`,
    DONE: `تم`,
    DONT_INCLUDE_UTENSILS: `عدم تضمين أدوات المائدة`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `استرداد EBT`,
    EBT_CHOICE_DIALOG_TITLE: `أي طريقة EBT ترغب في استخدامها؟`,
    EBT_CHOICE_CASH_BENEFIT: `الإعانة النقدية`,
    EBT_CHOICE_FOOD_STAMPS: `قسائم الطعام`,
    EBT_CARD_SUBTITLE: `مرّر بطاقة EBT على جهاز الدفع`,
    EDIT: `تعديل`,
    EDIT_ORDER: `تعديل الطلب`,
    EDIT_TIP: `تعديل الإكرامية`,
    SAVE_ORDER: `حفظ الطلب`,
    EMAIL_ADDRESS: `البريد الإلكتروني`,
    EMAIL_RECEIPT: `إيصال بالبريد الإلكتروني`,
    EMAIL_REQUIRED_FOR_RECEIPT: `البريد الإلكتروني مطلوب لإرسال إيصالك.`,
    EMAIL_RECEIPT_SEND_FAILED: `تعذّر إرسال الإيصال. يرجى المحاولة مرة أخرى.`,
    EMAIL_RECEIPT_SEND_SUCCESS: `تم إرسال الإيصال بنجاح.`,
    ENTER_ACCESS_CODE: `أدخل رمز الوصول:`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `أدخل بريدك الإلكتروني`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `تعذّر المسح؟ أدخل رقم بطاقتك.`,
    ENTER_PHONE_CONSENT: `أوافق على استلام مواد تسويقية عبر الرسائل النصية (SMS).`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `أدخل رقم هاتفك`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `مرحبًا {{$1 guest name}}، يرجى إدخال رقم هاتفك`,
    ENTER_PHONE_LOYALTY: `أدخل رقم هاتفك المحمول`,
    ENTER_PHONE_RECEIPT: `أدخل رقم هاتفك المحمول لاستلام الإيصال`,
    ENTER_PHONE_TEXT_WHEN_READY: `أدخل رقم هاتفك لتصلك رسالة نصية عندما يكون طلبك جاهزًا!`,
    ENTER_VEHICLE_DESCRIPTION: `يرجى إدخال تفاصيل مركبتك حتى نتمكن من إحضار طلبك إليك:`,
    ENTER_YOUR_COUPON_CODE: `أدخل رمز القسيمة`,
    ENTER_YOUR_COMP_CARD_NUMBER: `أدخل رقم بطاقة المجاملة`,
    ENTER_YOUR_COMP_CARD_PIN: `أدخل رمز PIN لبطاقة المجاملة`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `أدخل رقم بطاقة الهدايا`,
    ENTER_YOUR_GIFT_CARD_PIN: `أدخل رمز PIN لبطاقة الهدايا`,
    ENTER_YOUR_EMAIL: `أدخل بريدك الإلكتروني:`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `بريد إلكتروني غير صالح. يرجى المحاولة مرة أخرى.`,
    ENTER_YOUR_FIRST_NAME: `أدخل اسمك الأول:`,
    ENTER_YOUR_LAST_NAME: `أدخل الحرف الأول من اسم عائلتك:`,
    ENTER_YOUR_NAME: `أدخل اسمك:`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `اسم غير صالح. يرجى المحاولة مرة أخرى.`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `يرجى إدخال اسم.`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `يُسمح بحرف واحد فقط. يرجى المحاولة مرة أخرى.`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `يجب أن يحتوي الاسم على حروف فقط. يرجى المحاولة مرة أخرى.`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `يحتوي الاسم على كلمات غير لائقة. يرجى المحاولة مرة أخرى.`,
    ERROR: `عذرًا!`,
    ERROR_ADDING_ITEM: `حدث خطأ أثناء إضافة الصنف إلى سلتك. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى طلب المساعدة من أقرب موظف.`,
    ERROR_EDITING_ITEM: `حدث خطأ أثناء تعديل الصنف في سلتك. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى طلب المساعدة من أقرب موظف.`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `المبلغ يتجاوز رصيد البطاقة.`,
    ERROR_CARD_CONFIRMATION: `عذرًا! تعذّر تأكيد البطاقة. يرجى المحاولة مرة أخرى.`,
    ERROR_CARD_DECLINED: `تعذّر خصم المبلغ من البطاقة المحددة. يرجى المحاولة مرة أخرى.`,
    ERROR_CARD_INACTIVE: `عذرًا، بطاقة الطالب هذه غير مفعّلة.`,
    ERROR_CARD_NOT_FOUND: `عذرًا! لم نتمكن من العثور على هذه البطاقة. يرجى المحاولة مرة أخرى.`,
    ERROR_CARD_NUMBER_LENGTH: `عدد خانات رقم البطاقة غير صحيح.`,
    ERROR_CARD_RESTRICTED_TIME: `عذرًا، لا يمكن استخدام هذه البطاقة في الوقت الحالي.`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `عذرًا، {{$1: cardScheme}} غير مقبولة هنا. هل يمكنك تجربة بطاقة أخرى؟`,
    ERROR_COUPON_CONFIRMATION: `عذرًا! تعذّر استخدام رمز القسيمة. يرجى المحاولة مرة أخرى.`,
    ERROR_INVALID_EMAIL: `بريد إلكتروني غير صالح`,
    ERROR_INVALID_LOGIN_CREDS: `اسم المستخدم أو كلمة المرور غير صحيحة`,
    ERROR_INVALID_NAME: `يرجى إدخال اسم صالح`,
    ERROR_INVALID_PHONE_NUMBER: `يرجى إدخال رقم هاتف صالح`,
    ERROR_INVALID_ROOM_NUMBER: `يرجى إدخال رقم غرفة صالح`,
    ERROR_INVALID_TABLE_NUMBER: `يرجى إدخال رقم طاولة صالح`,
    ERROR_INVALID_VERIFICATION_CODE: `رمز التحقق غير صالح`,
    ERROR_KIOSK_CARD_DECLINED: `حدث خطأ ما. لم يتم خصم أي مبلغ من بطاقتك. يرجى المحاولة مرة أخرى.`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `فشلت قراءة البطاقة. يرجى المحاولة مرة أخرى.`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `لم يتمكن الجهاز من العثور على جهاز الدفع. لم يتم خصم أي مبلغ من بطاقتك. يرجى التواصل مع أحد الموظفين.`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `يبدو أن جهاز الدفع غير متصل. لم يتم خصم أي مبلغ من بطاقتك. يرجى التواصل مع أحد الموظفين.`,
    ERROR_ORDER_OPERATION: `عذرًا، لم نتمكن من معالجة طلبك. يرجى المحاولة مرة أخرى.`,
    ERROR_PIN_LENGTH: `عدد خانات رمز PIN غير صحيح.`,
    ERROR_RECEIVING_PAYMENT: `لم يتمكن جهاز الدفع من معالجة دفعتك. يرجى المحاولة مرة أخرى.`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `لم يتم استلام أي دفعة. لم يتم إرسال هذا الطلب. سيحتوي إيصالك على ملخص طلبك. يرجى التواصل مع أحد الموظفين للحصول على مزيد من المساعدة.`,
    ERROR_SENDING_ORDER: `مرحبًا، يبدو أن هناك مشكلة في إرسال طلبك إلى المطبخ. يرجى التواصل مع أحد الموظفين للمساعدة.`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `تم الدفع بنجاح، ولكن حدثت مشكلة أثناء إرسال طلبك إلى المطبخ. يرجى التواصل مع أحد الموظفين للمساعدة. سيحتوي إيصالك على ملخص طلبك.`,
    ERROR_STARTING_ORDER: `عذرًا، لم نتمكن من بدء طلبك. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى التواصل مع أحد الموظفين.`,
    ERROR_UPDATING_ORDER: `عذرًا، لم نتمكن من تحديث طلبك. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى التواصل مع أحد الموظفين.`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `تعذّر عرض هذا الصنف. لقد بلغت الحد المسموح به للكحول في هذا الطلب. يرجى إزالة صنف كحولي لإضافة هذا الصنف.`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `تعذّر عرض هذا الصنف. لقد بلغت حد العروض الخاصة في هذا الطلب. يرجى إزالة صنف من العروض الخاصة لإضافة هذا الصنف.`,
    EXIT: `خروج`,
    EXIT_CONFIRMATION: `هل أنت متأكد أنك تريد الخروج؟ سيؤدي الخروج إلى مسح طلبك.`,
    EXIT_TO_COVER: ``,
    FAVORITE: `مفضل`,
    FAVORITES: `المفضلة`,
    FAVORITES_NONE_YET: `لا توجد مفضلات بعد.`,
    FAVORITES_REMOVE_CONFIRMATION: `هل أنت متأكد أنك تريد إزالة هذا المفضل؟`,
    FETCHING_RECOMMENDATIONS: `جارٍ جلب التوصيات...`,
    FIND_ACCOUNT: `البحث عن حساب`,
    FIRST_NAME: `الاسم الأول`,
    FORGOT_PASSWORD: `هل نسيت كلمة المرور؟`,
    FULFILLMENT_LABEL_ADDRESS: `العنوان`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `البريد الإلكتروني`,
    FULFILLMENT_LABEL_GUEST_NAME: `لـ`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `رقم الطلب`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `رقم الطاولة`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `رقم الهاتف`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `رقم جهاز التتبع`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `وصف المركبة`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `سيتم توصيل طلبك إلى العنوان أدناه.`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `سنرسل لك الإيصال.`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `سيتم المناداة باسمك عندما يكون طلبك جاهزًا.`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `سيتم المناداة برقم طلبك.`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `ستصلك رسالة نصية عندما يكون طلبك جاهزًا.`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `سيتم تقديم طلبك على طاولتك.`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `سيرن جهاز التتبع الخاص بك عندما يكون الطلب جاهزًا.`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `سيتم إحضار طلبك إليك بمجرد وصولك خارج المطعم.`,
    FULFILLMENT_TOGGLE: `تبديل طريقة الاستلام النشطة`,
    FULL_NAME: `الاسم الكامل`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `عذرًا! تعذّر العثور على القائمة لذلك الوقت. يرجى المحاولة مرة أخرى.`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `عذرًا! لم نتمكن من العثور على مواعيد متاحة للطلب المستقبلي. يرجى تجربة خيار تناول آخر.`,
    FUTURE_ORDER_SET_FOR: `تم تحديد موعد الطلب:`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `عذرًا! الموعد الذي اخترته لم يعد متاحًا. يرجى اختيار موعد آخر.`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `حدث خطأ ما أثناء جلب المواعيد المتاحة. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى التواصل مع أحد الموظفين.`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `يرجى اختيار موعد.`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `المواعيد المتاحة`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `اليوم`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `غدًا`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `الاستلام اليوم في {{$1: time}}`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `الاستلام في يوم العمل التالي في {{$1: time}}`,
    FUTURE_ORDER_LEAD_TIME: `الوقت المقدّر لتجهيز الطلب: {{$1: time}}`,
    GENERIC_ERROR: `عذرًا! حدث خطأ ما!\nيرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى التواصل مع أحد الموظفين.`,
    GET_REWARDS: `احصل على المكافآت`,
    GET_RECEIPT: `الحصول على الإيصال`,
    GET_RECEIPT_DIALOG_TITLE: `خيارات الإيصال`,
    GIFT_CARD: `بطاقة الهدايا`,
    GIFT_CARD_SECONDARY: `بطاقة هدايا بديلة`,
    GIFT_CARD_TITLE: `ادفع الآن`,
    GIFT_CARD_SUBTITLE: `ادفع بتمرير بطاقة الهدايا على جهاز قراءة البطاقات.`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `خطأ في مسح بطاقة الهدايا`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `لم نتمكن من مسح بطاقة الهدايا الخاصة بك. يرجى المحاولة مرة أخرى.`,
    GIFT_CARD_APPLYING_TITLE: `جارٍ تطبيق بطاقة الهدايا`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `خطأ في تطبيق بطاقة الهدايا`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `لم نتمكن من تطبيق بطاقة الهدايا الخاصة بك. يرجى المحاولة مرة أخرى.`,
    GIFT_CARD_NO_BALANCE_TITLE: `رصيد بطاقة الهدايا غير كافٍ`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `لا يوجد رصيد في بطاقة الهدايا الخاصة بك.`,
    GIFT_CARD_ADD_ANOTHER: `إضافة أخرى`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `يرجى إدخال رقم بطاقة الهدايا.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `يرجى إدخال رقم بطاقة هدايا صالح.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `يرجى إدخال رقم بطاقة هدايا صالح.`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `يرجى إدخال رمز PIN.`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `يرجى إدخال رمز PIN صالح.`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `يرجى إدخال رمز PIN صالح.`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `أدخل رقم بطاقة الهدايا. يمكن أن تتكون الأرقام من {{$1: length}} خانة.`,
    GIFT_CARD_ENTERING_PIN_HINT: `أدخل رمز PIN. يمكن أن تتكون الأرقام من {{$1: length}} خانة.`,
    GIFT_CARD_ERROR_REMOVING: `خطأ في إزالة بطاقة الهدايا. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى التواصل مع أحد الموظفين.`,
    'gift-card.select-account.title': `اختر حسابًا`,
    'gift-card.select-account.loading': `جارٍ تحميل الحسابات...`,
    'gift-card.select-account.error.title': `تعذّر تحميل الحسابات`,
    'gift-card.select-account.error.message': `لم نتمكن من تحميل حساباتك. يرجى المحاولة مرة أخرى.`,
    'gift-card.select-account.column.account': `الحساب`,
    'gift-card.select-account.column.balance': `الرصيد الحالي`,
    'gift-card.select-account.error.toast-title': `خطأ`,
    'gift-card.select-account.error.toast-message': `فشل التحقق. يرجى المحاولة مرة أخرى.`,
    GLOSSARY_TERM_LEARN_MORE: `مزيد من المعلومات`,
    GOES_WELL_WITH: `يتناسب مع`,
    GRAND_TOTAL: `الإجمالي الكلي`,
    GROUP_ORDERING_ADD_GUEST: `إضافة ضيف`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `اسم الضيف يحتوي على رموز غير صالحة.`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `اسم الضيف مستخدم بالفعل. يرجى إدخال اسم مختلف.`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `الضيف {{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `طلب جماعي - لمن هذا الصنف؟`,
    GROUP_ORDERING_LABEL: `طلب جماعي - الصنف لـ:`,
    GROUP_ORDERING_TITLE: `الطلب الجماعي`,
    GROUP_ORDERING_SUBTITLE: `سيسألك خيار الطلب الجماعي عن الشخص الذي يخصه كل صنف من أفراد مجموعتك. اضغط على “نعم” لتفعيل الطلب الجماعي. اضغط على “لا” إذا كنت ترغب في المتابعة.`,
    GUEST_INFO: `معلومات الضيف`,
    GUEST_RATING_LABEL_0: `اضغط للتقييم بـ 0: غير راضٍ إطلاقًا`,
    GUEST_RATING_LABEL_1: `اضغط للتقييم بـ 1: غير راضٍ نوعًا ما`,
    GUEST_RATING_LABEL_2: `اضغط للتقييم بـ 2: راضٍ نوعًا ما`,
    GUEST_RATING_LABEL_3: `اضغط للتقييم بـ 3: راضٍ جدًا`,
    GUEST_RATING_0: `شكرًا لك على ملاحظاتك!`,
    GUEST_RATING_1: `شكرًا لك على ملاحظاتك!`,
    GUEST_RATING_2: `شكرًا لك على ملاحظاتك!`,
    GUEST_RATING_3: `شكرًا لك على ملاحظاتك!`,
    GUEST_RATING_SUBMITTED: `شكرًا لك على ملاحظاتك!`,
    HIDE: `إخفاء`,
    HOME: `الرئيسية`,
    HOW_DID_WE_DO: `كيف كان أداؤنا؟ قيّمنا!`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `كيف ترغب في الدفع؟`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `كيف ترغب في استلام طلبك؟`,
    KITCHEN_CLOSED: `عذرًا، المطبخ مغلق.`,
    ID_CHECK_LABEL: `طلبك يحتوي على كحول. قد يُطلب منك إظهار هوية.`,
    ID_CHECK_CODE_MESSAGE: `يلزم رمز وصول الموظف لإتمام الدفع لطلب يحتوي على كحول. يرجى طلب المساعدة من أحد أفراد الفريق.`,
    IE_WARNING: `لاحظنا أنك تتصفح موقعنا عبر Internet Explorer. للحصول على أفضل تجربة، يرجى فتحه بمتصفح مدعوم مثل Google Chrome أو Safari أو Firefox أو Microsoft Edge.`,
    INCLUDE_UTENSILS: `تضمين أدوات المائدة`,
    ITEM_86D: `مرحبًا، يبدو أن هناك مشكلة في إرسال طلبك إلى المطبخ بسبب نفاد أحد الأصناف. يرجى التواصل مع أحد الموظفين للمساعدة.`,
    ITEM_86D_VALIDATION: `مرحبًا، يبدو أن هناك مشكلة في إرسال طلبك إلى المطبخ بسبب نفاد أحد الأصناف. يرجى طلب المساعدة من أحد الموظفين.`,
    ITEM_RECIPIENT: `مُعد لـ`,
    ITEM_RECIPIENT_FOR: `مُعد لـ {{$1: recipient}}`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `موصى به`,
    ITEM_STEP_TITLE: `الخطوة {{$1: step}}`,
    ITEM_STEP_EMPTY: `لم يتم إجراء أي اختيارات في هذه الخطوة`,
    ITEM_STEP_NO_RECOS: `لا توجد توصيات متاحة`,
    ITEMS_NO_LONGER_IN_MENU: `تمت إزالة بعض الأصناف من سلتك لأنها لم تعد متوفرة في القائمة`,
    ITEM_SCAN_ERROR: `لم نتمكن من العثور على هذا الصنف. يرجى إضافته من القائمة أو طلب المساعدة من أحد الموظفين.`,
    ITEM_SCAN_SUCCESS: `تمت إضافة الصنف إلى السلة!`,
    LAST_NAME: `اسم العائلة`,
    LEAD_TIME_LONG: `قد يحتاج طلبك إلى وقت أطول من الموعد الذي اخترته حاليًا.`,
    LEAD_TIME_CART: `قد يستغرق تجهيز هذا الطلب وقتًا أطول من موعد الاستلام المطلوب بسبب بعض الأصناف المختارة.`,
    LANGUAGE_SELECT_LABEL: `اضغط لاختيار اللغة`,
    LOADING: `جارٍ التحميل...`,
    LOADING_MENU: `جارٍ تحميل القائمة...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `البحث عن المتاجر`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `ابحث عن متجر لـ {{$1: dine-in/take-away}}`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `كيف ترغب في الطلب؟`,
    LOCATION_SEARCH_HEADER: `مرحبًا بك في {{$1: org name}}`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `العنوان، المدينة والولاية، أو الرمز البريدي`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `تسجيل الدخول`,
    LOGIN: `تسجيل الدخول`,
    LOGIN_GIFT_CARD: `تسجيل الدخول ببطاقة الهدايا`,
    LOGIN_GIFT_CARD_SECONDARY: `تسجيل الدخول ببطاقة هدايا بديلة`,
    LOGIN_WALL_WELCOME: `مرحبًا!`,
    LOGIN_WALL_WELCOME_USER: `مرحبًا {{$1: user}}!`,
    LOGIN_WITH_CARD_NUMBER: `تسجيل الدخول برقم البطاقة`,
    LOGIN_WITH_PHONE: `تسجيل الدخول بالهاتف`,
    LOOKING_UP_ACCOUNT: `جارٍ البحث عن الحساب...`,
    LOOKUP_CARD: `جارٍ البحث عن البطاقة...`,
    LOOKUP_COUPON: `جارٍ البحث عن القسيمة...`,
    LOYALTY: `برنامج الولاء`,
    LOYALTY_ACCOUNT_APPLY: `تطبيق`,
    LOYALTY_CARD_NUMBER: `رقم البطاقة`,
    LOYALTY_EXIT_TO_MENU: `الانتقال إلى القائمة`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `امسح رمز QR من التطبيق`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `لا يوجد تطبيق؟ أدخل رقم هاتفك.`,
    LOYALTY_AUTH_METHOD_BARCODE: `امسح رمز QR من التطبيق`,
    LOYALTY_AUTH_METHOD_HID: `قرّب بطاقة HID`,
    LOYALTY_AUTH_METHOD_PHONE: `أدخل رقم هاتفك.`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `أدخل رقم بطاقتك.`,
    LOYALTY_AUTH_METHOD_EMAIL: `أدخل بريدك الإلكتروني.`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `أدخل بريدك الإلكتروني وكلمة المرور.`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `أدخل بريدك الإلكتروني ورقم هاتفك.`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `أدخل اسم المستخدم وكلمة المرور.`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `أدخل رقم هاتف حسابك:`,
    LOYALTY_APP_AUTH_SUBTITLE: `للعثور على الرمز الشريطي، افتح التطبيق على شاشة الدفع (PAY).`,
    LOYALTY_APP_AUTH_TITLE: `امسح الرمز الشريطي للدفع من تطبيقك باستخدام الماسح أدناه.`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `أدخل رمز المكافأة المكوّن من 7 خانات يدويًا`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `أدخل رمز مكافأة مكوّنًا من 7 خانات:`,
    LOYALTY_APPLY_REWARD_FAILED: `تعذّر تطبيق المكافأة. يرجى المحاولة مرة أخرى.`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `تعذّر تطبيق المكافآت التالية: {{$1: reward names}}. يرجى المحاولة مرة أخرى.`,
    LOYALTY_APPLYING_REWARD: `جارٍ تطبيق المكافأة...`,
    LOYALTY_AUTH_GENERIC_ERROR: `عذرًا! لم نتمكن من العثور على حساب المكافآت هذا. يرجى المحاولة مرة أخرى.`,
    LOYALTY_AUTH_INSTRUCTIONS: `سجّل الدخول لكسب نقاط برنامج المكافآت واستخدامها.`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `المكافآت المتاحة`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `الرصيد الحالي`,
    LOYALTY_CANNOT_MODIFY_REWARD: `عذرًا، لا يمكنك تعديل مكافآتك بعد دفع قيمة الطلب.`,
    LOYALTY_CANNOT_REMOVE_REWARD: `عذرًا، لا يمكن إزالة هذه المكافأة بعد تطبيقها على الطلب.`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `أدخل رقم بطاقتك لكسب نقاط برنامج المكافآت واستخدامها.`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `عذرًا، لا يمكنك استخدام مكافآتك لأن هناك قسيمة مطبّقة.`,
    LOYALTY_GETTING_REWARDS: `جارٍ جلب مكافآتك...`,
    LOYALTY_FETCH_REWARDS_FAILED: `تعذّر جلب المكافآت. يرجى المحاولة مرة أخرى.`,
    LOYALTY_REWARD_APPLY: `تطبيق`,
    LOYALTY_REWARD_APPLY_FAILED: `تعذّر تطبيق المكافآت. قد لا تنطبق بعض المكافآت على طلبك.`,
    LOYALTY_REWARD_APPLIED: `تم التطبيق`,
    LOYALTY_REWARD_INVALID: `غير صالحة`,
    LOYALTY_REWARD_LABEL_MEAL: `وجبة`,
    LOYALTY_REWARD_LABEL_MEALS: `وجبات`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `استبدل الآن`,
    LOYALTY_REWARD_LABEL_SELECTED: `محددة`,
    LOYALTY_REWARD_LABEL_APPLIED: `تم الاستبدال`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `يتم الاستبدال عند الدفع`,
    LOYALTY_REWARD_LABEL_REMOVING: `جارٍ الإزالة`,
    LOYALTY_REWARD_LABEL_ERROR: `خطأ في التطبيق`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `غير قابلة للتطبيق`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `المكافآت`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `مكافآت بنسبة مئوية`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `مكافآت ثابتة`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `مكافآت المحفظة`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `مكافآت المحفظة والدفع`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `مكافآت الأصناف المجانية`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `مكافآت استبدال الوجبات`,
    LOYALTY_REWARDS_FOR: ` لـ`,
    LOYALTY_NO_REWARDS_LABEL: `لا توجد مكافآت`,
    LOYALTY_NO_REWARDS_NO_EARNING: `لا توجد مكافآت مؤهلة لهذه الأصناف.`,
    LOYALTY_NO_REWARDS_TEXT: `لا توجد مكافآت مؤهلة لهذه الأصناف، لكنك ستكسب نقاطًا من هذا الطلب!`,
    LOYALTY_PAYMENT: `عبر برنامج الولاء`,
    LOYALTY_PAYMENT_CARD_CHARGED: `سيتم خصم {{$1: charge_amount}} من البطاقة المسجّلة.`,
    LOYALTY_PAYMENT_FAILED: `تعذّر تطبيق الدفع.`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `حدثت مشكلة أثناء معالجة الدفع عبر برنامج الولاء. يرجى المحاولة مرة أخرى أو اختيار طريقة دفع أخرى.`,
    USE_LOYALTY_PAYMENT: `استخدام برنامج الولاء`,
    LOYALTY_PAYMENT_SUBMIT: `إتمام الدفع`,
    LOYALTY_PAYMENT_REWARD: `مخصوم من برنامج الولاء`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `سيتم خصم قيمة هذه المعاملة من بطاقتك المسجّلة لدى مزود الخدمة.`,
    LOYALTY_PAY_WITH_APP: `الدفع عبر التطبيق`,
    LOYALTY_EARNED_POINT_ESTIMATE: `نقاط المكافآت المقدّرة لهذا الطلب:`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number }} نقطة`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `حالة الحساب`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `لم نتمكن من العثور على حسابك.`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `يرجى تسجيل الدخول إلى حسابك أدناه لكسب النقاط واستبدال المكافآت.`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `التسجيل برقم الهاتف`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `لا يزال بإمكانك كسب نقاط على طلبك اليوم بمسح إيصال الطلب بعد التسجيل!`,
    LOYALTY_INTRO_QR_SIGN_IN: `يرجى مسح رمز QR الخاص بك أدناه لتسجيل الدخول.`,
    LOYALTY_INTRO_QR_SIGN_UP: `يرجى مسح رمز QR أدناه للتسجيل.`,
    LOYALTY_INTRO_WELCOME_BACK: `مرحبًا، `,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `رقم الهاتف الذي أدخلته مرتبط بأكثر من حساب ولاء واحد أو أنه غير موجود.`,
    LOYALTY_REDEMPTION_CODE: `تطبيق رمز الاستبدال`,
    LOYALTY_REMOVING_REWARD: `جارٍ إزالة المكافأة...`,
    LOYALTY_SCAN_FAILED_TITLE: `فشل المسح`,
    LOYALTY_SCAN_FAILED_MESSAGE: `لم نتمكن من مسح رمز QR الخاص بك. يرجى المحاولة مرة أخرى.`,
    LOYALTY_SIGN_OUT_NOTICE: `سيتم تسجيل خروجك تلقائيًا عند إتمام طلبك أو مغادرتك القائمة.`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `سيتم تسجيل خروجك تلقائيًا عند إتمام طلبك أو مغادرتك القائمة. لا يتم حفظ كلمات المرور إطلاقًا.`,
    LOYALTY_SIGN_UP_SMS_SENT: `تم إرسال رسالة التسجيل!`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `العودة إلى تسجيل الدخول`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `تم التسجيل بنجاح!`,
    LOYALTY_SIGN_UP_WITH_QR: `التسجيل برمز QR`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `التسجيل برقم الهاتف`,
    LOYALTY_WELCOME_TITLE: `اكسب المكافآت واستخدمها`,
    LOYALTY_SIGNUP_TITLE: `احصل على رابط التسجيل عبر هاتفك`,
    LOYALTY_YOU_CURRENTLY_HAVE: `لديك حاليًا`,
    LOYALTY_NAV_REWARDS: `مكافآتي`,
    LOYALTY_NAV_ORDER_HISTORY: `طلباتي`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `لقد تجاوزت الحد الأقصى لعدد محاولات تسجيل الدخول.`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `لقد تجاوزت الحد الأقصى لعدد محاولات الوصول إلى بطاقة الهدايا.`,
    MAKE_IT_A_COMBO: `هل تريد جعلها وجبة كومبو؟`,
    MAKE_IT_A_COMBO_MOD: `هل تريد إضافتها ككومبو؟`,
    MAKE_IT_A_COMBO_ACCEPT: `نعم، من فضلك!`,
    MAKE_IT_A_COMBO_REJECT: `لا، شكرًا!`,
    MAKE_IT_A_COMBO_NO: `لا، شكرًا، بدون كومبو.`,
    MAKE_IT_A_COMBO_YES: `هل تريد جعلها وجبة كومبو؟`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `اختيار رائع!`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `اختر طبقك الجانبي ومشروبك أدناه!`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `أضف طبقًا جانبيًا ومشروبًا لتحصل على وجبة كومبو!`,
    MENU_COVER_ALT_TEXT: `اضغط هنا لبدء الطلب`,
    MENU_COVER_LOYALTY_TEXT: `سجّل الدخول إلى برنامج الولاء لكسب النقاط واستبدال المكافآت.`,
    MENU_COVER_QUIZ_TEXT: `أجب عن الاختبار لتكتشف الصنف المناسب لك!`,
    MENU_COVER_WAYFINDER_TEXT: `انتقل إلى دليل المواقع لتجد طريقك`,
    MAINTENANCE_COVER_TITLE: `هذا الجهاز قيد الصيانة`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `يرجى التأكد من توصيل جهاز HID بالجهاز.`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `انقطاع اتصال HID`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `يرجى التأكد من توصيل نظام KDS بالجهاز.`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `انقطاع اتصال KDS`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `يرجى تجربة جهاز آخر أو طلب المساعدة من أحد الموظفين.`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `هذا الجهاز غير متاح حاليًا`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `يرجى التأكد من توصيل قارئ الشريط المغناطيسي بالجهاز.`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `انقطاع اتصال قارئ الشريط المغناطيسي`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `يرجى التأكد من اتصال الجهاز بالشبكة.`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `لا يوجد اتصال بالشبكة`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `يواجه هذا الجهاز مشكلة في الاتصال بسبب انخفاض سرعة الإنترنت.\n\nيرجى التحقق من استقرار الاتصال.\n\nالسرعة الموصى بها: 10 Mbps كحد أدنى للتحميل والتنزيل.`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `تم اكتشاف شبكة غير مستقرة`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `يرجى التأكد من تشغيل جهاز الدفع وتوصيله بالجهاز.`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `انقطاع اتصال جهاز الدفع`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `يرجى التأكد من إغلاق غطاء الطابعة.`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `غطاء الطابعة مفتوح`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `يرجى التأكد من توصيل الطابعة بالجهاز.`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `انقطاع اتصال الطابعة`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `يرجى التأكد من وجود ورق في الطابعة.`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `نفد الورق من الطابعة`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `يرجى التأكد من توصيل الميزان بالجهاز.`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `انقطاع اتصال الميزان`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `يرجى التأكد من توصيل الماسح بالجهاز.`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `انقطاع اتصال الماسح`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `الحد الأقصى المسموح به للمشروبات الكحولية في الطلب الواحد هو {{$1: number}}`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `الحد الأقصى المسموح به للأصناف الخاصة في الطلب الواحد هو {{$1: number}}`,
    MENU_COVER_DINING_OPTIONS: `كيف ترغب في الطلب؟`,
    MENU_COVER_LANGUAGE_OPTIONS: `اختر لغة للبدء`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `اضغط هنا لبدء الطلب وعرض هذا الصنف المميز: {{$1: item name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `اضغط هنا لبدء الطلب والانتقال مباشرة إلى هذا القسم المميز: {{$1: section name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `اضغط هنا لبدء الطلب والانتقال مباشرة إلى هذه الصفحة المميزة: {{$1: page name}}!`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `اضغط هنا لبدء الطلب لـ "{{$1: fulfillment method}}"!`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `العودة إلى خيارات التناول`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `العودة إلى رقم الهاتف`,
    MARKETING_CONSENT: `أرغب في تلقي الأخبار والتحديثات والخصومات والعروض`,
    MENU_FILTERS_DIETARY_FILTERS: `الخيارات الغذائية`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `حدد الوسوم الغذائية التي تنطبق عليك. ستظهر في القائمة.`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `التفضيلات الغذائية`,
    MENU_FILTERS_OTHER_FILTERS: `أخرى`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `القيود الغذائية`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `إذا كنت تعاني من عدم تحمّل لأطعمة معينة، فحدد أحد هذه الخيارات لإخفائها من القائمة`,
    MENU_FILTERS_COUNT: `{{$1: number}} من التفضيلات الغذائية نشطة. اضغط للتعديل.`,
    MOD_86D: `مرحبًا، يبدو أن هناك مشكلة في إرسال طلبك إلى المطبخ بسبب نفاد أحد الأصناف. يرجى التواصل مع أحد الموظفين للمساعدة. يُرجى العلم أن دفعتك قد تم قبولها من قبل المطعم.`,
    MOD_GROUP_AGGREGATE_QUANTITY: `{{$1: number range, e.g. 2-3}} أصناف بالإجمالي`,
    MOD_GROUP_CHOICES_INCREMENT: `بمضاعفات {{$1: number, e.g. you have to get 2/4/6 sauces}}`,
    MOD_GROUP_CHOICES_MAKE_ONE: `اختر خيارًا واحدًا فريدًا`,
    MOD_GROUP_CHOICES_MAKE_X: `اختر {{$1: number range, e.g. 2-3}} خيارات مختلفة`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `{{$1: number range, e.g. 2-3}} لكل خيار`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `اختر {{$1: number}} على الأقل`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `اختر ما بين {{$1: number}} و {{$2: number}}`,
    MOD_GROUP_CHOOSE_ONE: `اختر واحدًا`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `اختر واحدًا كحد أقصى`,
    MOD_GROUP_CHOOSE_UP_TO_X: `اختر {{$1: number}} كحد أقصى`,
    MOD_GROUP_CHOOSE_X: `اختر {{$1: number}}`,
    MOD_GROUP_DEEMPHASIZE_SHOW: `إظهار - {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `إخفاء - {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: ``,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: ``,
    MOD_GROUP_WALLET_FIRST_X_FREE: `أول {{$1: number}} مجانًا.`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `الأول مجانًا.`,
    MOD_GROUP_WALLET_UP_TO_X: `حتى {{$1: number}} بسعر {{$2: dollar amount}} لكل خيار`,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `إغلاق الاستبدال`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `تغيير الاستبدال`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `استبدال`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `إضافة إلى الصنف`,
    MOD_RECOMMENDED_BADGE: `موصى به`,
    MOD_UPSELL_PROMPT_TITLE: `إضافة خيار؟`,
    MOD_UPSELL_PROMPT_ACCEPT: `إضافة`,
    MOD_UPSELL_PROMPT_DECLINE: `لا، شكرًا`,
    MODIFY: `تعديل`,
    MODIFY_INGREDIENTS: `تعديل المكونات`,
    MORE: `المزيد`,
    NAME_CALLED_ORDER_READY: `سيتم المناداة باسمك عندما يكون طلبك جاهزًا.`,
    NAME_ON_CARD: `الاسم على البطاقة`,
    NEED_MORE_TIME: `هل تحتاج إلى مزيد من الوقت؟`,
    NEW_PASSWORD: `كلمة المرور الجديدة`,
    NEXT: `التالي`,
    NO: `لا`,
    NO_ITEMS_MATCH_FILTERS: `لا توجد أصناف تطابق عوامل التصفية.`,
    NO_ORDERS_MATCH: `لا توجد طلبات تطابق بحثك.`,
    NO_THANKS: `لا، شكرًا`,
    NO_TIP: `بدون إكرامية`,
    NOT_A_MEMBER: `لست عضوًا؟`,
    NUTRITION_INFO_CALORIES: `سعرات`,
    NUTRITION_INFO_PROTEIN: `بروتين`,
    NUTRITION_INFO_FAT: `دهون`,
    NUTRITION_INFO_CARBS: `كربوهيدرات`,
    NUTRITION_INFO_SUGAR: `سكريات`,
    OK: `موافق`,
    OR: `أو`,
    OPT_OUT_OF_RECOMMENDATIONS: `إيقاف تلقي التوصيات`,
    ORDER_GET_ERROR: `عذرًا، واجهتنا مشكلة في إنشاء طلبك. يرجى المحاولة مرة أخرى.`,
    ORDER_HISTORY: `سجل الطلبات`,
    ORDER_HISTORY_EMPTY: `لا توجد طلبات في سجلك. بمجرد تقديم طلب، سيظهر هنا.`,
    ORDER_HISTORY_ERROR: `عذرًا، واجهتنا مشكلة في تحميل سجل طلباتك. يرجى المحاولة مرة أخرى.`,
    ORDER_SENT: `تم إرسال الطلب`,
    ORDER_SUMMARY: `ملخص الطلب`,
    ORDER_SUMMARY_WITH_NAME: `ملخص الطلب لـ {{$1 guest name}}`,
    ORDER_SUMMARY_LABEL: `ملخص الطلب. طلب {{$1 fulfillment}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `ملخص الطلب. طلب {{$1 fulfillment}} باسم {{$2 guest name}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `ملخص الطلب. طلب {{$1 fulfillment}} للطاولة {{$2: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `ملخص الطلب. طلب {{$1 fulfillment}} لجهاز التتبع رقم {{$2: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `ملخص الطلب. طلب {{$1 fulfillment}} باسم {{$2 guest name}} على الطاولة {{$3: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `ملخص الطلب. طلب {{$1 fulfillment}} باسم {{$2 guest name}} لجهاز التتبع رقم {{$3: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `ملخص الطلب. طلب {{$1 fulfillment}} للطلب رقم {{$2: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `ملخص الطلب. طلب {{$1 fulfillment}} لجهاز التتبع رقم {{$2: tracker number}} للطلب رقم {{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `ملخص الطلب. طلب {{$1 fulfillment}} للطاولة {{$2: table number}} للطلب رقم {{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `ملخص الطلب. طلب {{$1 fulfillment}} باسم {{$2 guest name}} للطلب رقم {{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `ملخص الطلب. طلب {{$1 fulfillment}} باسم {{$2 guest name}} على الطاولة {{$3: table number}} للطلب رقم {{$4: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `ملخص الطلب. طلب {{$1 fulfillment}} باسم {{$2 guest name}} على جهاز التتبع {{$3: tracker number}} للطلب رقم {{$4: order number}}`,
    ORDER_THROTTLE_MAX_EXCEEDED: `عذرًا! يستقبل المطعم طلبات أكثر مما يستطيع تلبيته. يرجى تجربة موعد آخر للطلب.`,
    ORDER_TIME_ASAP: `اطلب في أقرب وقت ممكن`,
    ORDER_TIME_LATER: `لاحقًا اليوم`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `يوم العمل التالي`,
    ORDER_TIME_FUTURE: `الطلب لوقت لاحق`,
    ORDER_TOTAL_MAX_EXCEEDED: `للطلبات الكبيرة، يرجى مراجعة أحد الموظفين.`,
    ORDER_UPDATE_FAILED: `تعذّر تحديث الطلب.`,
    ORDER_VALIDATION_IN_PROGRESS: `جارٍ التحقق من طلبك`,
    ORDER_VALIDATION_FAILED: `عذرًا! حدث خطأ ما!`,
    ORDER_WAS_PLACED: `تم تقديم طلبك.`,
    ORDERING_MODE_CHANGED: `تم تغيير وضع الطلب. تمت إعادة تعيين جلستك.`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `اضغط هنا لتحويل {{$1: ordered item name}} إلى وجبة كومبو.`,
    ORDERED_ITEM_COMBO_LABEL: `كومبو`,
    ORDERING_ITEM_ABSENCE_RESET: `كان هذا الصنف غير محدّث. تمت إعادة الصنف إلى حالته الأصلية. يرجى المحاولة مرة أخرى.`,
    OUR_MENU: `قائمتنا`,
    OUTPOST_PICKUP: `الاستلام من نقطة التسليم`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `أدخل رقم غرفتك في نقطة التسليم`,
    OUTPOST_ROOM_NUMBER_TITLE: `رقم الغرفة`,
    OUT_OF_STOCK: `غير متوفر`,
    PAGE_NAVIGATION_TITLE: `اضغط على أحد الخيارات أدناه للانتقال إلى صفحة معينة في القائمة. {{$1: total}} صفحات متاحة.`,
    PARTIAL_PAYMENT_LINE: `دفعة جزئية`,
    PARTIAL_PAYMENT_WARNING_TITLE: `دفعة جزئية`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `توجد دفعة جزئية على هذا الطلب. إذا أردت الرجوع، سيتم استرداد دفعتك أولًا.`,
    PASSWORD: `كلمة المرور`,
    PASSWORD_REQUIREMENTS: ``,
    PASSWORD_UPDATED: ``,
    PASSWORD_UPDATED_LOG_IN_AGAIN: ``,
    PARTIAL_TENDER_TIMEOUT: `مرحبًا، إذا لم تكمل الدفع خلال الدقائق الخمس القادمة، فسنلغي الطلب ونسترد دفعتك.`,
    PAY_AT_CASHIER: `يرجى التوجه إلى أمين الصندوق للدفع.`,
    PAY_NOW: `ادفع الآن`,
    PAY_WITH: `الدفع عبر`,
    PAY_WITH_CREDIT: `الدفع ببطاقة الائتمان`,
    PAY_WITH_DEBIT_CREDIT: `الدفع ببطاقة الخصم/الائتمان`,
    PAYMENT: `الدفع`,
    PAYMENT_DETAILS: `تفاصيل الدفع`,
    PAYMENT_LINE_LABEL_DONATION: `تبرع بقيمة {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `المجموع الفرعي هو {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PARTIAL: `دفعة جزئية بقيمة {{$1: amount}}`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `استبدال بطاقة هدايا من {{$1: name}} بقيمة {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COUPON: `خصم قسيمة من {{$1: name}} بقيمة {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `خصم قسيمة من {{$1: name}} بقيمة {{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `دفع عبر EBT بقيمة {{$1: amount}}`,
    PAYMENT_LINE_LABEL_LOYALTY: `استبدال مكافآت من {{$1: name}} بقيمة {{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `استبدال مكافأة من {{$1: name}} بقيمة {{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `خصم من {{$1: name}} بقيمة {{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `الضريبة هي {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TIP: `الإكرامية هي {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `رسوم خدمة بقيمة {{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `رسوم خدمة بقيمة {{$1: amount}} مقابل {{$2: name}}`,
    PAYMENT_LINE_LABEL_TOTAL: `الإجمالي الكلي هو {{$1: amount}}`,
    PAYMENT_LINE_LABEL_REMAINING: `الرصيد المتبقي هو {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PAID: `المبلغ المدفوع هو {{$1: amount}}`,
    PAYMENT_OPTION_LABEL_CASH: `اضغط للدفع نقدًا`,
    PAYMENT_OPTION_LABEL_CARD: `اضغط للدفع ببطاقة ائتمان`,
    PAYMENT_OPTION_LABEL_COUPON: `اضغط لاستبدال قسيمة`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `اضغط لاستبدال بطاقة مجاملة`,
    PAYMENT_OPTION_LABEL_DONATION: `اضغط لإضافة تبرع أو تعديله`,
    PAYMENT_OPTION_LABEL_EBT: `اضغط للدفع عبر EBT`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `اضغط لاسترداد EBT`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `اضغط للدفع من الإعانة النقدية في EBT`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `اضغط للدفع من قسائم الطعام في EBT`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `اضغط للدفع ببطاقة هدايا`,
    PAYMENT_OPTION_LABEL_LOYALTY: `اضغط لاستبدال المكافآت`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `اضغط لاستبدال المكافآت`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `اضغط لإتمام الدفع`,
    PAYMENT_PROMPT_NFC: `ادفع عبر جهاز البطاقات بإدخال بطاقتك أو تقريب هاتفك.`,
    PAYMENT_PROMPT_DIP: `ادفع عبر جهاز البطاقات بإدخال بطاقتك.`,
    PAYMENT_SUCCESSFUL: `تم الدفع بنجاح`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `عذرًا، فشلت عملية الدفع. يرجى المحاولة مرة أخرى.`,
    PAYMENT_KIOSK_TIMEOUT: `عذرًا، انتهت مهلة جلسة الدفع. يرجى المحاولة مرة أخرى.`,
    PAYMENT_TOTAL: `إجمالي الدفع`,
    PAYMENT_WAS_TAKEN: `يُرجى العلم أنه تم خصم دفعتك.`,
    PAYMENT_WAS_NOT_TAKEN: `يُرجى العلم أنه لم يتم خصم دفعتك. هذا ليس تأكيدًا للدفع.`,
    PHONE_NUMBER: `رقم الهاتف`,
    PICK_UP: `الاستلام`,
    PICK_UP_AT: `الاستلام من`,
    PICK_UP_ENTER_NUMBER: `يرجى أخذ رقم وإدخاله أدناه:`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `مرحبًا {{$1: guest name}}، يرجى أخذ رقم وإدخاله أدناه:`,
    PICK_UP_ENTER_NUMBER_TRACKER: `يرجى أخذ جهاز تتبع وإدخال رقمه:`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `مرحبًا {{$1: guest name}}، يرجى أخذ جهاز تتبع وإدخال رقمه:`,
    PLACE_ORDER: `تقديم الطلب`,
    PLEASE_ENTER_A_VALID_AMOUNT: `يرجى إدخال مبلغ صالح للاسترداد.`,
    PLEASE_USE_TEST_CARD: `لا يزال هذا الموقع في وضع الاختبار. يرجى استخدام بطاقة اختبار للدفع.`,
    PLEASE_WAIT: `يرجى الانتظار...`,
    PRICE: `السعر هو {{$1:price}}`,
    PRINTING_RECEIPT: `جارٍ طباعة إيصالك...`,
    PRINT_RECEIPT: `طباعة الإيصال`,
    PRINT_RECEIPT_ERROR: `عذرًا، حدث خطأ أثناء طباعة إيصالك. يرجى المحاولة لاحقًا.`,
    PRINTED_RECEIPT_COMMAND: `الرجاء تذكّر أخذ الإيصال!`,
    PROCESSING_PAYMENT: `جارٍ معالجة الدفع...`,
    PROMOTED_MODIFIER: `عرض مميز!`,
    QUANTITY_SELECT: `{{$1:quantity}} محددة`,
    QUANTITY_SELECT_INCREASE: `زيادة الكمية`,
    QUANTITY_SELECT_DECREASE: `تقليل الكمية`,
    QUANTITY_SELECT_LABEL: ``,
    QUIT: `خروج`,
    QUICK_CHECKOUT: `دفع سريع`,
    QUICK_NAV_TAP_TO_VIEW: `اضغط للعرض:`,
    QUIZ_RESULTS_TITLE: `النتائج`,
    QUIZ_RESULTS_EMPTY: `لم يتم العثور على نتائج. حاول مرة أخرى بإجابات مختلفة.`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `اضغط لعرض النتيجة التالية. {{$1:index}} من {{$2:total}}`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `اضغط لعرض النتيجة السابقة. {{$1:index}} من {{$2:total}}`,
    QUIZ_STEP_ERROR: `يرجى الإجابة عن جميع الأسئلة قبل المتابعة.`,
    QUIZ_STEP_ANSWER_LABEL: `اضغط للإجابة بـ {{$1:badge name}}:`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `امسح رمز QR للحصول على نسخة من إيصالك على هاتفك.`,
    RECEIPT_AUTHORIZATION: `التفويض`,
    RECEIPT_CARD_NUMBER: `رقم البطاقة#`,
    RECEIPT_CHECK_ID: `التحقق من الهوية`,
    RECEIPT_DISCOUNTS: `الخصومات`,
    RECEIPT_DONATION: `تبرع`,
    RECEIPT_FAILED: `مرحبًا، يبدو أن هناك مشكلة في إرسال طلبك إلى المطبخ.\n\nيرجى التواصل مع أحد الموظفين للمساعدة.`,
    RECEIPT_FAILED_ITEM_86D: `مرحبًا، يبدو أن هناك مشكلة في إرسال طلبك إلى المطبخ بسبب نفاد أحد الأصناف. يرجى طلب المساعدة من أحد الموظفين.`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `لم تُدرج الأصناف التالية في رمز QR لعدم ارتباطها برمز PLU:`,
    RECEIPT_NOT_RECEIPT: `هذا ليس إيصالًا ولا إثبات شراء.`,
    RECEIPT_ORDER: `الطلب`,
    RECEIPT_ORDER_TOTAL: `إجمالي الطلب`,
    RECEIPT_PAY_AT_CASHIER: `يرجى الدفع لدى أمين الصندوق`,
    RECEIPT_PICK_UP_AT_LABEL: `الاستلام من`,
    RECEIPT_PICKUP_TIME_LABEL: `وقت الاستلام`,
    RECEIPT_DELIVERY_TIME_LABEL: `وقت التوصيل`,
    RECEIPT_PRINTED: `تمت طباعة الإيصال`,
    RECEIPT_REFUNDED: `تم الاسترداد`,
    RECEIPT_REMAINING_BALANCE: `الرصيد المتبقي`,
    RECEIPT_SELF_SERVE: `خدمة ذاتية:`,
    RECEIPT_SPECIAL_REQUEST: `طلب خاص`,
    RECEIPT_SUB_TOTAL: `المجموع الفرعي`,
    RECEIPT_TAX_TOTAL: `إجمالي الضريبة`,
    RECEIPT_TIP_THANKS: `إكرامية (شكرًا!)`,
    RECEIPT_SERVICE_CHARGE: `رسوم الخدمة`,
    RECEIPT_TRANS_NO: `رقم معاملة الجهاز`,
    RECEIPT_YOUR_CHECK_NUMBER: `رقم فاتورتك هو`,
    RECOMMENDATIONS: `التوصيات`,
    RECOMMENDED_FOR_YOU: `موصى به لك`,
    REFUND: `استرداد`,
    REFUNDER_ALREADY_REFUNDED: `تم الاسترداد`,
    REFUNDER_DELAY_MESSAGE: `قد يستغرق ظهور المبالغ المستردة في كشف حسابك بضعة أيام.`,
    REFUNDER_INSTRUCTIONS: `ابحث عن الطلبات باستخدام رقم التفويض الموجود على الإيصال، أو رقم الطلب، أو البريد الإلكتروني، أو رقم الهاتف، أو آخر أربعة أرقام من البطاقة، أو الرقم المرجعي للمعاملة، أو معرّف الطلب.`,
    REFUNDER_SEARCH_PLACEHOLDER: `رقم تفويض الإيصال، أو رقم الطلب، أو آخر أربعة أرقام من البطاقة`,
    REFUNDER_TITLE: `استرداد طلب`,
    REFUNDER_SEARCHING_TITLE: `جارٍ البحث`,
    REFUNDER_RESULTS_TITLE: `الطلبات`,
    REFUNDER_RESULTS_EMPTY: `لم يتم العثور على طلبات. يرجى التحقق من معايير البحث والمحاولة مرة أخرى.`,
    REFUNDER_REFUNDING_TITLE: `جارٍ الاسترداد`,
    REFUNDER_REFUND_ERROR: `حدث خطأ أثناء معالجة الاسترداد. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى التواصل مع الدعم.`,
    REFUNDER_REFUND_SUCCESS: `تم الاسترداد بنجاح! ستتم معالجة المعاملة قريبًا.`,
    REFUNDER_REFUND_SUCCESS_BACK: `ابحث مرة أخرى`,
    REFUNDER_SEARCH_INPUT_ERROR: `يرجى إدخال رقم تفويض، أو رقم طلب، أو آخر أربعة أرقام من البطاقة بشكل صحيح.`,
    REFUNDER_SEARCH_ERROR: `حدث خطأ أثناء البحث عن طلبك. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يرجى التواصل مع الدعم.`,
    REFUNDING: `جارٍ معالجة الاسترداد...`,
    REFUND_FAILED: `فشل الاسترداد. يرجى المحاولة لاحقًا.`,
    REMOVE: `إزالة`,
    REMOVE_CARD: `لا تنسَ سحب بطاقتك.`,
    REMOVE_COMP_CARD: `إزالة بطاقة المجاملة`,
    REMOVE_COUPON: `إزالة القسيمة`,
    REMOVE_GIFT_CARD: `إزالة`,
    REMOVE_TIP: `إزالة الإكرامية`,
    REMOVING_COUPON: `جارٍ إزالة القسيمة...`,
    REPEAT_PASSWORD: `تكرار كلمة المرور`,
    RESET: `إعادة تعيين`,
    REWARDS: `المكافآت`,
    REWARDS_LOGGED_IN: `المكافآت`,
    REWARDS_APPLICABLE_TO_ORDER: `قابلة للتطبيق على طلبك الآن`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `غير قابلة للتطبيق على طلبك بعد`,
    REWARDS_EDIT: `تعديل المكافآت`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}} نقطة`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}} وجبة`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}} نقطة`,
    SAVE: `تحديث`,
    SAVE_CARD: `حفظ البطاقة في الحساب لعمليات الشراء المستقبلية.`,
    SCAN_COUPON_BELOW: `يمكنك مسح القسائم باستخدام الماسح أدناه.`,
    SCAN_YOUR_GIFT_CARD: `امسح بطاقة الهدايا`,
    SEARCH: `بحث`,
    SEARCH_BEGIN: `أدخل كلمة البحث أدناه للبدء.`,
    SEARCH_EMPTY: `لم يتم العثور على نتائج. جرّب كلمة بحث مختلفة.`,
    SEARCH_HINT: `ابحث عن الأصناف باستخدام أي مزيج من الاسم أو الوصف.`,
    SECRET_MENU_IMAGE_ALT: `اضغط لعرض القائمة السرية`,
    SELECT_DATE: `اختر التاريخ`,
    SELF_SERVE: `خدمة ذاتية`,
    SEND: `إرسال`,
    SEND_LOYALTY_SMS: `إرسال رسالة نصية`,
    SEND_ORDER_UI_TIMEOUT: `مرحبًا، ما زلنا نحاول إرسال طلبك إلى المطبخ. يرجى طلب المساعدة من أحد الموظفين.`,
    SENT_LOYALTY_SIGNUP_SMS: `تم إرسال الرسالة النصية! تفقّد هاتفك وسجّل في الوقت المناسب لك.`,
    SENDING_ORDER_KITCHEN: `جارٍ إرسال الطلب إلى المطبخ...`,
    SENDING_ORDER_VALIDATION: `جارٍ تأكيد الطلب...`,
    SENDING_RECEIPT: `جارٍ إرسال الإيصال...`,
    SENDING_SMS: `جارٍ إرسال الرسالة النصية...`,
    SERVICE_CHARGE: `رسوم الخدمة`,
    SHOW: `إظهار`,
    SHOW_NUTRITION: `عرض المعلومات الغذائية`,
    SHOW_STAFF_FIRST: `يرجى إظهار هذه الرسالة لأحد الموظفين قبل الخروج.\nهل تريد الخروج فعلًا؟`,
    SIGNUP_CTA: `سجّل للحصول على حساب!`,
    SIGN_OUT: `تسجيل الخروج`,
    SIGN_UP: `التسجيل`,
    SIGNUP_BENEFITS: `أنشئ حسابًا لحفظ بطاقتك الائتمانية وأصنافك المفضلة لتسهيل الدفع.`,
    SIGNUP_LOYALTY: `التسجيل في برنامج الولاء`,
    SKIP: `تخطي`,
    SPECIAL_REQUESTS: `طلبات خاصة`,
    SPECIAL_REQUESTS_EXAMPLE: `مثال: الصلصة جانبًا، بدون أنشوفة، إلخ.`,
    SPECIAL_REQUESTS_FINEPRINT: `قد تترتب على الاستبدالات والطلبات الخاصة رسوم إضافية.`,
    SPECIAL_REQUESTS_ADD: `إضافة طلب خاص`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `الطلب الخاص طويل جدًا.`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `يرجى استخدام الحروف والأرقام وعلامات الترقيم فقط.`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `يرجى إدخال طلب خاص.`,
    SR_REMOVE_ITEM_FROM_CART: `إزالة الصنف من السلة.`,
    STARTING_ORDER: `جارٍ بدء الطلب...`,
    UPDATING_ORDER: `جارٍ تحديث الطلب...`,
    START_ORDER_BY_SCANNING: `ابدأ طلبك بمسح صنف في أسفل الجهاز.`,
    START_NEW_ORDER: `ابدأ طلبًا آخر`,
    STORED_VALUE_REMAINING_BALANCE: `متبقٍ`,
    STORE_INFO: ``,
    STORE_INFORMATION: `معلومات المتجر`,
    STUDENT_CARD: `بطاقة الطالب`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `عذرًا، لا يوجد رصيد كافٍ في بطاقة الطالب هذه.`,
    STUDENT_CARD_SUBTITLE_HID: `قرّب بطاقة الطالب للدفع`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `قرّب بطاقة الطالب أو مرّرها للدفع`,
    STUDENT_CARD_SUBTITLE_MSR: `مرّر بطاقة الطالب للدفع`,
    SUBMIT: `إرسال`,
    SUBTOTAL: `المجموع الفرعي`,
    SUBTOTAL_REDUCED: `المجموع الفرعي بعد التخفيض`,
    SUBTOTAL_INCREASED: `المجموع الفرعي الجديد`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `أنت توفّر بفضل وجبة الكومبو!`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `أنت توفّر`,
    SUCCESS: `تم بنجاح`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `تغيير الموقع`,
    SWITCH_TO_CATERING: `التحويل إلى خدمة التموين`,
    SWITCH_TO_WEB: `التحويل إلى الطلب عبر الإنترنت`,
    SWIPE_YOUR_GIFT_CARD: `مرّر بطاقة الهدايا للدفع`,
    SWIPE_YOUR_COMP_CARD: `مرّر بطاقة المجاملة للدفع`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `مرّر بطاقة الهدايا أو امسحها للدفع`,
    TAKING_LONGER_THAN_USUAL: `يستغرق الأمر وقتًا أطول من المعتاد...`,
    TAP_HERE_FOR_LANGUAGE: `اضغط هنا لـ {{$1: language, e.g. 'English'}}`,
    TAP_OUTSIDE_CLOSE: `اضغط خارج النافذة للإغلاق`,
    TAP_TO_REDEEM: `اضغط للاستبدال`,
    TAXES: `الضريبة`,
    TERMS_OF_SERVICE: `شروط الخدمة`,
    TERMS_OF_SERVICE_LOAD_FAILED: `حدث خطأ أثناء تحميل شروط الخدمة`,
    TEXT_RECEIPT: `إيصال عبر رسالة نصية`,
    TEXT_RECEIPT_SEND_FAILED: `تعذّر إرسال الإيصال عبر رسالة نصية.`,
    TEXT_RECEIPT_SEND_SUCCESS: `تم إرسال الإيصال!`,
    TEXT_YOU_WHEN_READY: `سنرسل لك رسالة نصية عندما يكون طلبك جاهزًا.`,
    THANK_YOU: `شكرًا لك!`,
    THEN_PRESS_BUTTON_1: `ثم اضغط على زر`,
    THEN_PRESS_BUTTON_2: `.`,
    TIP: `إكرامية`,
    TIPPING: `جارٍ إضافة الإكرامية...`,
    TIP_AMOUNT_TOO_HIGH: `مبلغ الإكرامية مرتفع جدًا.`,
    TIP_AMOUNT_TOO_LOW: `مبلغ الإكرامية منخفض جدًا.`,
    TIP_FAILED: `عذرًا! تعذّرت إضافة الإكرامية. يرجى المحاولة مرة أخرى.`,
    TIP_CANNOT_BE_MODIFIED: `عذرًا! لا يمكنك تعديل الإكرامية بعد دفع قيمة الطلب.`,
    TIP_LABEL_PERCENT: `اضغط لإضافة إكرامية بنسبة {{$1: percent}}% ({{$2: amount}})`,
    TIP_LABEL_FIXED: `اضغط لإضافة إكرامية بقيمة {{$1: amount}}`,
    TIP_LABEL_CUSTOM: `اضغط لإضافة إكرامية مخصصة`,
    TIP_LABEL_NONE: `اضغط لإزالة الإكرامية`,
    TO_GO: `طلب سفري`,
    TOTAL: `الإجمالي`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `تغيّرت أسعار بعض الأصناف في طلبك.`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `تغيّر المجموع الفرعي وأصبح الآن`,
    TOTAL_CHANGED_LEADING_TEXT: `تغيّر الإجمالي وأصبح الآن`,
    TOTAL_CHANGED_TRAILING_TEXT: `. هل تريد المتابعة في الطلب؟`,
    TOTAL_PAID: `إجمالي المدفوع`,
    TOTAL_REMAINING: `إجمالي المتبقي`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `حاول مرة أخرى`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `يبدو أننا لم نتمكن من تحديد موقعك. يرجى إدخال عنوانك.`,
    UNAVAILABLE_ITEM: `عذرًا، لم يعد هذا الصنف متوفرًا.`,
    UNIT_GRAM: `{{$1: amount}}g`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}} سعرة حرارية`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}} بروتين`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}} كربوهيدرات`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}} دهون`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}} سكريات`,
    UP_TO_X: `حتى {{$1: number}}`,
    USE_COMP_CARD: `استخدام بطاقة المجاملة`,
    USE_COUPON: `استخدام قسيمة`,
    USE_EBT_CARD: `بطاقة EBT`,
    USE_EBT_CASH_BENEFIT: `الإعانة النقدية في EBT`,
    USE_EBT_FOOD_STAMP: `قسائم الطعام في EBT`,
    USE_GIFT_CARD: `استخدام بطاقة الهدايا`,
    USERNAME: `اسم المستخدم`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `البريد الإلكتروني غير صالح`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `{{$1: field name, e.g. 'email'}} مطلوب`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `هذا الحقل مطلوب`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `يرجى استخدام الحروف والأرقام فقط`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `يرجى استخدام الحروف والأرقام و & و # أو . فقط`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `يجب أن تحتوي كلمة المرور على رقم واحد على الأقل وحرف كبير وحرف صغير، وألا تقل عن 14 خانة.`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `رقم الهاتف غير صالح`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `يجب أن يكون الرمز البريدي أرقامًا`,
    VENDOR_UNAVAILABLE_MESSAGE: `هذا المتجر مغلق حاليًا. يرجى التحقق من ساعات العمل والعودة في وقت آخر.`,
    VEHICLE_COLOR: `لون المركبة`,
    VEHICLE_MAKE: `صانع المركبة`,
    VEHICLE_MODEL: `طراز المركبة`,
    VERIFY_ACCOUNT: `التحقق من الحساب`,
    VERIFY_ACCOUNT_CTA: `تحقّق من حسابك لتبدأ في تقديم الطلبات.`,
    VIDEO_LOAD_FAILED: `تعذّر تحميل الفيديو`,
    VIEW: `عرض`,
    WE_APOLOGIZE: `نعتذر عن أي إزعاج.`,
    WEIGHING_INSTRUCTIONS: `ضع الصنف على الميزان.`,
    WELCOME_BACK: `مرحبًا بعودتك! أصناف مختارة خصيصًا لك:`,
    WELCOME_BACK_WITH_NAME: `مرحبًا بعودتك {{$1: guest name}}! أصناف مختارة خصيصًا لك:`,
    WELCOME_TO: `مرحبًا بك في {{$1: org name}}!`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `اختر موعد الطلب`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `أين ترغب في استلام طلبك؟`,
    YES: `نعم`,
    YOU_PREVIOUSLY_ORDERED: `طلبت سابقًا`,
    YOUR_CURRENT_LOCATION: `موقعك الحالي`,
    YOUR_NAME: `اسمك`,
    YOUR_ORDER: `طلبك`,
    YOUR_SUBTOTAL: `مجموعك الفرعي`,
    ZOOM_TOGGLE_ON: `اضغط لتفعيل التكبير بإصبعين`,
    ZOOM_TOGGLE_OFF: `اضغط لإلغاء تفعيل التكبير بإصبعين`,
    ZOOM_INSTRUCTIONS: `تم تفعيل التكبير بإصبعين. استخدم إصبعين للتكبير والتصغير.`,
    STARBUCKS_COVER_1_BUTTON: `أعرف ما أريد`,
    STARBUCKS_COVER_2_BUTTON: `استكشف المكان`,
    STARBUCKS_COVER_2_TITLE: `تجارب وتذوّق وتعلّم`,
    STARBUCKS_COVER_PROMO_A: `دليل القهوة`,
    STARBUCKS_COVER_PROMO_B: `Starbucks Rewards`,
    STARBUCKS_EXPERIENCES_TITLE: `التجارب`,
    STARBUCKS_EXPERIENCES_SUBTITLE: `انغمس في حرفية القهوة وعروضها وابتكاراتها عند حجز تجربة مميزة`,
    STARBUCKS_EXPERIENCES_RESERVE_NOW: `احجز لليوم`,
    STARBUCKS_EXPERIENCES_RESERVE_LATER: `احجز لوقت لاحق`,
    STARBUCKS_EXPERIENCES_BACK: `العودة إلى التجارب`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `مزيد من المعلومات`,
    STARBUCKS_WAYFINDER_CARD_MENU_BUTTON: `الانتقال إلى القائمة`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `أين أنا؟`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `أنت هنا`,
    STARBUCKS_WAYFINDER_BATHROOMS_LABEL: `دورات المياه`,
    STARBUCKS_WAYFINDER_OPEN_SEATING_LABEL: `مقاعد متاحة`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `ابحث عن مكان`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `اسحب بإصبعك لاستكشاف المكان.`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `اضغط على مكان مميز لمعرفة المزيد عنه.`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_TITLE: `روح المغامرة`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_SUBTITLE: `ما مدى المغامرة التي تفضلها في قهوتك؟`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_TITLE: `النكهات المفضلة`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_SUBTITLE: `عندما تفكر في قهوتك، أي النكهات تبدو لك ألذ؟`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_TITLE: `القوة`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_SUBTITLE: `ما مدى قوة القهوة التي تستمتع بها؟`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_TITLE: `طلب القهوة المفضل`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_SUBTITLE: `كيف تفضل عادةً أن تطلب قهوتك؟`,
    STARBUCKS_COFFEE_FINDER_QUESTION_EDIT: `اضغط للتعديل`,
    STARBUCKS_COFFEE_FINDER_QUESTION_CONFIRM: `أكّد اختيارك`,
    STARBUCKS_COFFEE_FINDER_QUESTION_RESTART: `ابدأ من جديد`,
    STARBUCKS_COFFEE_FINDER_ANSWER_TITLE: `يبدو أنك ستستمتع بـ`,
    STARBUCKS_COFFEE_FINDER_ANSWER_SUBTITLE: `اشترِ الحبوب فقط، أو ننصحك بالمشروب أدناه المحضّر من هذه الحبوب:`,
    STARBUCKS_COFFEE_FINDER_ANSWER_GO_TO_MENU: `عرض القائمة الكاملة`,
    STARBUCKS_COFFEE_FINDER_ANSWER_RESTART: `ابدأ من جديد`,
    STARBUCKS_VIEW_WAYFINDER: `استكشف المكان`,
    STARBUCKS_VIEW_COFFEE_FINDER: `ضيّق خياراتي`,
    STARBUCKS_VIEW_EXPERIENCES: `عرض التجارب`,
    'cover.session.timeout': `حدث خطأ ما. يرجى المحاولة مرة أخرى.`,
    'cover.reduced-height.button': `ابدأ الطلب`,
    'cover.loyalty.title': `مرحبًا`,
    'cover.five-guys.documents': `معلومات الطعام في Five Guys`,
    'cover.five-guys.allergen-nutrition': `معلومات مسببات الحساسية والقيمة الغذائية`,
    'cover.five-guys.ingredients': `المكونات`,
    'cover.five-guys.storm-document-instructions': `اضغط على اليسار لعرض معلومات مسببات الحساسية والقيمة الغذائية. اضغط على اليمين لعرض المكونات.`,
    'cover.loyalty.login': `تسجيل الدخول ببرنامج الولاء`,
    'cover.loyalty.guest': `المتابعة كضيف`,
    'guest-identifier.button.quit': `خروج`,
    'guest-identifier.button.skip': `تخطي`,
    'guest-identifier.button.back': `رجوع`,
    'guest-identifier.button.next': `متابعة`,
    'guest-identifier.button.submit.cover': `متابعة`,
    'guest-identifier.button.submit.edit': `متابعة`,
    'guest-identifier.button.submit.checkout': `متابعة`,
    'guest-identifier.phone.tos.button-back': `رجوع`,
    'guest-identifier.phone.tos.title': `شروط الخدمة`,
    'guest-identifier.phone.tos.link': `شروط خدمة رقم الهاتف`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `سجّل الدخول بحساب الولاء الخاص بك`,
    'guest-identifier.name.loyalty-button': `تسجيل الدخول ببرنامج الولاء`,
    'guest-identifier.name.loyalty-separator': `أو`,
    'guest-identifier.name.loyalty-error-title': `عذرًا! لم يتم العثور على اسم`,
    'guest-identifier.name.loyalty-error-description': `عذرًا، لم نتمكن من العثور على اسم مرتبط بالحساب. يرجى إدخال اسمك أدناه`,
    'inactivity-timer.button.continue': `نعم، أحتاج إلى مزيد من الوقت`,
    'inactivity-timer.button.exit': `لا، لقد انتهيت`,
    'item-card.add.with-quantity': `إضافة ({{$1: quantity}})`,
    'image.scan.default.alt': `امسح الرمز الشريطي أو رمز QR`,
    'loyalty.view_coupons': `عرض القسائم`,
    'loyalty.add_coupons': `إضافة قسائم`,
    'loyalty.label.manual_redemption': `رمز الاستبدال`,
    'loyalty.label.manual_redemption_instructions': `أدخل رمز الاستبدال لاستبدال مكافأتك`,
    'loyalty.label.welcome.new-user': `مرحبًا {{$1: user}}! أصبح لديك الآن حساب ولاء`,
    'loyalty.reward_label.payment_unapplied': `تطبيق الدفع على البطاقة المسجّلة`,
    'loyalty.reward_label.redeemable_unredeemed': `استبدل باستخدام {{$1: points}} نقطة`,
    'loyalty.reward_label.payment_at_checkout': `يمكن تطبيق الدفع عند إتمام الطلب.`,
    'loyalty.reward_group_label.payment': `مكافآت الدفع`,
    'loyalty.rewards.payment-reward.name': `الدفع من الرصيد`,
    'loyalty.rewards.payment-reward.name-with-amount': `الدفع من الرصيد ({{$1: amount}})`,
    'loyalty.rewards.payment-reward.description': `رصيدك الحالي`,
    'loyalty.rewards.card-on-file-payment.description': `سيتم خصم الدفعة من بطاقتك المسجّلة.`,
    'loyalty.redemption_auth.back_to_rewards': `العودة إلى المكافآت`,
    'loyalty.redemption_auth.subtitle': `امسح الرمز الشريطي للاستبدال لاستبدال مكافأتك`,
    'loyalty.redemption_auth.submit': `استبدال المكافأة`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': `يوجد حساب مسجل بهذا البريد الإلكتروني. استخدم بريدًا إلكترونيًا آخر أو سجّل الدخول.`,
    'loyalty.signup.email-and-sms-consent': `أوافق على استلام مواد تسويقية عبر الرسائل النصية (SMS) والبريد الإلكتروني.`,
    'loyalty.signup.enter-your-email-address': `أدخل بريدك الإلكتروني`,
    'loyalty.signup.enter-your-name': `أدخل اسمك`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `يرجى قبول الشروط والأحكام للمتابعة.`,
    'loyalty.checkout-signup.header': `فرصتك الأخيرة للتسجيل وكسب المكافآت على هذا الطلب!`,
    'loyalty.checkout-signup.skip': `تخطٍ ومتابعة إلى الدفع`,
    'loyalty.checkout-signup.success.new-account.title': `تم إنشاء حساب جديد`,
    'loyalty.checkout-signup.success.new-account.description': `شكرًا لانضمامك، ستكسب مكافآت على هذا الطلب!`,
    'loyalty.checkout-signup.success.existing-account.title': `الحساب موجود بالفعل`,
    'loyalty.checkout-signup.success.existing-account.description': `سبق أن سجّلت بهذا الرقم. تم تسجيل دخولك الآن.`,
    'loyalty.checkout-signup.error.title': `خطأ في إنشاء الحساب`,
    'loyalty.checkout-signup.error.description': `حدث خطأ ما أثناء إنشاء الحساب`,
    'loyalty.checkout-signup.error.skip': `تخطٍ ومتابعة إلى الدفع`,
    'loyalty.checkout-signup.error.try-again': `حاول مرة أخرى`,
    'menu.item.reset': `إعادة تعيين الصنف`,
    'menu.mod-group.quick-select': `اختيار سريع`,
    'menu.mod-group.quick-select-active': `محدد`,
    'menu.mod-group.quick-select-clear': `اضغط لإلغاء التحديد`,
    'menu.page.scanner.initial.title': `امسح الأصناف لبدء الطلب`,
    'menu.page.scanner.scanned.title': `أصناف السلة`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `عرض الأصناف الممسوحة`,
    'order-history.button.add-to-order': `إضافة الأصناف المتاحة ({{$1: number}})`,
    'order-history.title': `سجل الطلبات`,
    'order-history.subtitle': `ستظهر هنا جميع طلباتك السابقة. تفاعل مع الأصناف لعرضها أو إضافتها إلى طلبك الحالي. يمكنك إضافة جميع أصناف أي طلب بضغطة واحدة.`,
    'order-history.next-page': `التالي`,
    'order-history.previous-page': `السابق`,
    'order-history.screen.close': `إغلاق`,
    'order-history.screen.error.title': `حدث خطأ ما`,
    'order-history.screen.error.subtitle': `تعذّر تحميل سجل الطلبات - يرجى المحاولة لاحقًا.`,
    'order-history.screen.error.button.back': `رجوع`,
    'order-history.screen.error.button.retry': `إعادة المحاولة`,
    'order-history.screen.no-orders': `لم يتم العثور على طلبات سابقة. عند تقديم طلب، عد إلى هنا لعرضه.`,
    'order-history.screen.order-has-quick-add-uneligible-items': `بعض الأصناف في هذا الطلب غير متاحة لإعادة الطلب السريع. يرجى إضافة الأصناف بالضغط عليها واحدًا تلو الآخر.`,
    'order-history.section.button.view-all': `عرض المزيد من طلباتي`,
    'order-history.topbar.button.back': `رجوع`,
    'loyalty.unapplicable_rewards_warning_title': `مكافآت غير قابلة للتطبيق`,
    'loyalty.unapplicable_rewards_warning_description': `لاستبدال المكافأة المحددة، يرجى إضافة الأصناف المؤهلة إلى سلتك. سيتم تطبيق المكافأة والخصم عند الدفع.`,
    'loyalty.unapplicable_rewards_warning_confirm': `تطبيق`,
    'loyalty.discard_reward_changes.title': `تجاهل تغييرات المكافآت؟`,
    'loyalty.discard_reward_changes.description': `لديك تغييرات على المكافآت لم يتم تطبيقها. هل تريد تجاهل تغييراتك؟`,
    'loyalty.discard_reward_changes.keep_editing': `متابعة التعديل`,
    'loyalty.discard_reward_changes.discard': `تجاهل التغييرات`,
    'loyalty.rewards.terms_button_label': `اضغط لعرض التفاصيل`,
    'loyalty.rewards.terms_dialog.apply': `تطبيق المكافأة`,
    'loyalty.rewards.terms_dialog.remove': `إزالة المكافأة`,
    'loyalty.rewards.terms_dialog.back': `رجوع`,
    'loyalty.reward_ineligible.title': `مكافأتك "{{$1: reward name}}" غير مؤهلة بعد`,
    'loyalty.reward_ineligible.title_generic': `مكافأتك غير مؤهلة بعد`,
    'loyalty.reward_ineligible.title_plural': `{{$1: count}} مكافآت غير مؤهلة بعد`,
    'loyalty.reward_ineligible.description': `طلبك غير مؤهل لهذه المكافأة بعد. عُد إلى القائمة لتعديل طلبك، أو تابع بدونها.`,
    'loyalty.reward_ineligible.description_plural': `طلبك غير مؤهل لهذه المكافآت بعد. عُد إلى القائمة لتعديل طلبك، أو تابع بدونها.`,
    'loyalty.reward_ineligible.back_to_menu': `العودة إلى القائمة`,
    'loyalty.reward_ineligible.continue': `المتابعة بدونها`,
    'loyalty.reward_ineligible.continue_plural': `المتابعة بدونها`,
    'loyalty.auth_method.manual_redemption': `إدخال يدوي`,
    'loyalty.button.menu.authed': `المكافآت`,
    'loyalty.button.menu.unauthed': `المكافآت`,
    'loyalty.button.checkout.authed': `المكافآت`,
    'loyalty.button.checkout.unauthed': `المكافآت`,
    'loyalty.error.reward_failed_to_apply': `تعذّر تطبيق المكافأة. يرجى المحاولة مرة أخرى.`,
    'loyalty.login.pin.label': `أدخل رمز PIN`,
    'loyalty.login.pin.error-required': `يرجى إدخال رمز PIN.`,
    'loyalty.login-options.button.skip.menu': `تخطٍ ومتابعة إلى القائمة`,
    'loyalty.login-options.button.skip.checkout': `تخطٍ ومتابعة إلى الدفع`,
    'loyalty.login-options.button.skip.dining-option-collection': `تخطٍ ومتابعة إتمام الطلب`,
    'loyalty.login-options.title': `اختر طريقة لتسجيل الدخول أو تابع كضيف`,
    'loyalty.login-options.subtitle': `يمكنك دائمًا تسجيل الدخول لاحقًا`,
    'loyalty.login-options.signup.link': `ليس لديك حساب؟ سجّل الآن`,
    'loyalty.login-options.barcode.title': `مسح الرمز الشريطي`,
    'loyalty.login-options.barcode.subtitle': `امسح الرمز الشريطي لتسجيل الدخول`,
    'loyalty.login-options.email-phone-number.title': `البريد الإلكتروني ورقم الهاتف`,
    'loyalty.login-options.email-phone-number.subtitle': `أدخل بريدك الإلكتروني ورقم هاتفك لتسجيل الدخول`,
    'loyalty.login-options.email-password.title': `البريد الإلكتروني وكلمة المرور`,
    'loyalty.login-options.email-password.subtitle': `أدخل بريدك الإلكتروني وكلمة المرور لتسجيل الدخول`,
    'loyalty.login-options.username-password.title': `اسم المستخدم وكلمة المرور`,
    'loyalty.login-options.username-password.subtitle': `أدخل اسم المستخدم وكلمة المرور لتسجيل الدخول`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `رقم الهاتف`,
    'loyalty.login-options.phone-number.subtitle': `أدخل رقم هاتفك لتسجيل الدخول`,
    'loyalty.login-options.card-number.title': `رقم البطاقة`,
    'loyalty.login-options.card-number.subtitle': `أدخل رقم بطاقتك لتسجيل الدخول`,
    'loyalty.login-options.email.title': `البريد الإلكتروني`,
    'loyalty.login-options.email.subtitle': `أدخل بريدك الإلكتروني لتسجيل الدخول`,
    'loyalty.login-options.or': `أو`,
    'loyalty.login-options.popup.close': `إغلاق`,
    'loyalty.error.or': `أو`,
    'loyalty.login-error.saved-form': `المعلومات التي أرسلتها:`,
    'loyalty.login-error.try-again.button': `حاول مرة أخرى`,
    'loyalty.otp.enter-code.title': `أدخل الرمز الذي أرسلناه لك`,
    'loyalty.otp.sent-to.email': `أرسلنا رمزًا عبر البريد الإلكتروني إلى {{$1: masked email}}`,
    'loyalty.otp.sent-to.sms': `أرسلنا رمزًا عبر رسالة نصية إلى {{$1: masked phone number}}`,
    'loyalty.otp.verify': `تحقّق`,
    'loyalty.otp.resend': `إعادة إرسال الرمز`,
    'loyalty.otp.code.error.invalid': `هذا الرمز غير صحيح. يرجى المحاولة مرة أخرى.`,
    'loyalty.otp.send-error.message': `لم نتمكن من مطابقة حساب واحد بالضبط لهذه المعلومات. يرجى التحقق منها والمحاولة مرة أخرى.`,
    'loyalty.login.fallback.phone-number.button': `استخدم رقم الهاتف بدلًا من ذلك`,
    'loyalty.login.fallback.barcode.button': `امسح رمزًا شريطيًا أو رمز QR بدلًا من ذلك`,
    'loyalty.login.fallback.card-number.button': `استخدم رقم البطاقة بدلًا من ذلك`,
    'loyalty.login.fallback.email.button': `استخدم البريد الإلكتروني بدلًا من ذلك`,
    'loyalty.login.fallback.email-phone-number.button': `استخدم البريد الإلكتروني ورقم الهاتف بدلًا من ذلك`,
    'loyalty.login.fallback.email-password.button': `استخدم البريد الإلكتروني وكلمة المرور بدلًا من ذلك`,
    'loyalty.login.fallback.username-password.button': `استخدم اسم المستخدم وكلمة المرور بدلًا من ذلك`,
    'loyalty.login.auth-method.phone-number.title': `رقم الهاتف`,
    'loyalty.login.auth-method.barcode.title': `مسح رمز شريطي أو رمز QR`,
    'loyalty.login.auth-method.card-number.title': `رقم البطاقة`,
    'loyalty.login.auth-method.email.title': `البريد الإلكتروني`,
    'loyalty.login.auth-method.email-phone-number.title': `البريد الإلكتروني ورقم الهاتف`,
    'loyalty.login.auth-method.email-password.title': `البريد الإلكتروني وكلمة المرور`,
    'loyalty.login.auth-method.username-password.title': `اسم المستخدم وكلمة المرور`,
    'vitrine.error.order_validation_failed': `تعذّر التحقق من الطلب. يرجى المحاولة مرة أخرى.`,
    'vitrine.error.handshake_failed': `تعذّر الاتصال بالجهاز. يرجى التواصل مع أحد الموظفين للمساعدة.`,
    'vitrine.error.request_timeout': `تعذّر إكمال الطلب. يرجى المحاولة مرة أخرى.`,
    'vitrine.error.request_aborted': `تعذّر إكمال الطلب. يرجى المحاولة مرة أخرى.`,
    'vitrine.error.analytics_send_error': `تعذّر إرسال البيانات التحليلية. يرجى المحاولة مرة أخرى.`,
    'vitrine.error.garcon_incompatible_build': `تعذّر الاتصال بالجهاز. يرجى التواصل مع أحد الموظفين للمساعدة.`,
    'vitrine.error.loyalty-login-no-matching-user-title': `تعذّر العثور على حسابك`,
    'vitrine.error.loyalty-login-no-matching-user-message': `لم نعثر على مستخدم بالمعلومات التي أدخلتها.`,
    'vitrine.error.loyalty_not_enough_points': `لا يحتوي حسابك على نقاط كافية لاستبدال المكافآت المحددة.`,
    'vitrine.error.order_total_above_max': `تجاوز إجمالي الطلب الحد الأقصى المسموح به. يرجى التواصل مع أحد الموظفين للمساعدة.`,
    'vitrine.error.empty_menu': `القائمة التي اخترتها فارغة حاليًا. يرجى تجربة خيار تناول آخر.`,
    'maitred.error.integration_bad_config': `يبدو أن هناك مشكلة في إعدادات الجهاز. يرجى التواصل مع أحد الموظفين للمساعدة.`,
    'checkout.done.expo_receipt.error': `تعذّرت طباعة الإيصال. يرجى المحاولة مرة أخرى.`,
    'checkout.done.expo_receipt.success': `تم إرسال الإيصال! يرجى طلب المساعدة من أحد أفراد الفريق.`,
    'checkout.done.print-receipt.out-of-paper': `نفد الورق من الطابعة. يرجى مراجعة أحد أفراد الفريق للحصول على إيصالك.`,
    'refunder.viewing-results.button.cancel': `إلغاء`,
    'refunder.viewing-results.button.refund-all': `استرداد الكل`,
    'refunder.viewing-results.button.view-transaction': `عرض المعاملات`,
    'refunder.viewing-results.button.done': `تم`,
    'refunder.viewing-results.button.back': `رجوع`,
    'refunder.viewing-results.button.search': `البحث عن طلب`,
    'refunder.viewing-results.refund-order.error-print-receipt': `تم استرداد الطلب بنجاح، لكننا لم نتمكن من طباعة الإيصال. يرجى محاولة الطباعة مرة أخرى.`,
    'refunder.viewing-results.refund-order.success': `تم استرداد الطلب بنجاح.`,
    'refunder.viewing-results.refund-order.error': `تعذّر استرداد الطلب. يرجى المحاولة مرة أخرى.`,
    'refunder.viewing-results.order.refunded': `تم استرداد الطلب`,
    'refunder.viewing-results.order.total': `إجمالي الطلب`,
    'refunder.search-form.button.back': `رجوع`,
    'refunder.search-form.button.search': `بحث`,
    'refunder.viewing-order.title': `جميع معاملات الطلب رقم {{$1: order number}}`,
    'refunder.viewing-order.subtitle': `يرجى اختيار المعاملة التي ترغب في استردادها.`,
    'refunder.viewing-order.button.cancel': `إلغاء`,
    'refunder.viewing-order.button.refund': `استرداد`,
    'refunder.viewing-order.button.refund-partial': `استرداد جزئي`,
    'refunder.viewing-order.button.retry': `إعادة المحاولة`,
    'refunder.viewing-order.button.done': `تم`,
    'refunder.viewing-order.button.back': `رجوع`,
    'refunder.viewing-order.refund-transaction.error': `تعذّر استرداد المعاملة. يرجى المحاولة مرة أخرى.`,
    'refunder.viewing-order.refund-transaction.success': `تم استرداد المعاملة بنجاح.`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `تم استرداد المعاملة بنجاح، لكننا لم نتمكن من طباعة الإيصال. يرجى محاولة الطباعة مرة أخرى.`,
    'refunder.viewing-order.transaction.total': `الإجمالي`,
    'refunder.viewing-order.transaction.refunded': `تم الاسترداد`,
    'refunder.viewing-order.error.title': `خطأ`,
    'refunder.viewing-order.error.message': `تعذّر تحميل الطلب. يرجى المحاولة مرة أخرى.`,
    'refunder.viewing-order.error.button.retry': `إعادة المحاولة`,
    'refunder.viewing-order.error.button.back': `رجوع`,
    'refunder.partial-transaction-refund.error.amount-too-high': `المبلغ مرتفع جدًا.`,
    'refunder.partial-transaction-refund.error.amount-too-low': `المبلغ منخفض جدًا.`,
    'refunder.partial-transaction-refund.error.amount-invalid': `المبلغ غير صالح.`,
    'refunder.partial-transaction-refund.error.amount-required': `المبلغ مطلوب.`,
    'refunder.partial-transaction-refund.error': `حدثت مشكلة أثناء معالجة الاسترداد. يرجى المحاولة مرة أخرى.`,
    'refunder.partial-transaction-refund.button.submit': `إرسال استرداد جزئي`,
    'refunder.partial-transaction-refund.button.back': `رجوع`,
    'refunder.partial-transaction-refund.title': `استرداد جزئي للمعاملة`,
    'refunder.partial-transaction-refund.hint': `يرجى إدخال المبلغ الذي ترغب في استرداده. الحد الأقصى هو {{$1: amount}}`,
    'refunder.partial-transaction-refund.label': `المبلغ`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.group-ordering.actions.change-recipient': `تعديل المستلم`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `إسناد الصنف إلى`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `إلغاء`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `إضافة جديد`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `إعادة الإسناد`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `لمن هذا الصنف؟`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `إسناد إلى هذا الضيف`,
    'checkout.cart.starbucks-stars': `صنف بقيمة {{$1: amount}} \u2605`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'menu.nav.starbucks.menu': `القائمة الرئيسية`,
    'menu.nav.starbucks.experiences': `التجارب`,
    'menu.nav.starbucks.wayfinder': `استكشاف المكان`,
    'menu.secret-menu.access-code.title': `أدخل رمز الوصول`,
    'menu.secret-menu.access-code.button.back': `رجوع`,
    'menu.secret-menu.access-code.button.submit': `إرسال`,
    'menu.secret-menu.access-code.error': `رمز وصول غير صالح`,
    'menu.secret-menu.access-code.success': `تم قبول رمز الوصول`,
    'menu.toast.added-to-cart': `تمت الإضافة إلى السلة`,
    'menu.toast.combo-savings': `توفير مع الكومبو!`,
    'menu.toast.discount-applied': `تم تطبيق الخصم!`,
    'menu.exit-verification.title': `مطلوب تحقق من المدير`,
    'menu.exit-verification.description': `يلزم رمز وصول الموظف للخروج. يرجى طلب المساعدة من أحد أفراد الفريق.`,
    'menu-item.starbucks-stars': `{{$1: amount}} \u2605`,
    'menu-item.product-information.title': `معلومات المنتج`,
    'menu-item.product-information.open': `عرض معلومات المنتج`,
    'menu-item.product-information.tab.product-info': `معلومات المنتج`,
    'menu-item.product-information.tab.nutrition': `القيمة الغذائية`,
    'menu-item.product-information.tab.allergens': `مسببات الحساسية`,
    'menu-item.product-information.nutrition.option': `الخيار {{$1: number}}`,
    'menu-item.product-information.empty': `المعلومات غير متوفرة.`,
    'menu-item.scale.title': `يرجى وضع الصنف على الميزان.`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `الوزن`,
    'menu-item.scale.price-per-unit': `{{$1: price}} لكل {{$2: unit}}`,
    'menu-item.scale.price': `السعر`,
    'menu-item.scale.instructions': `استخدم الميزان لوزن الصنف. لإعادة التعيين، اضغط على الزر المشار إليه على الميزان.`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `جارٍ الوزن...`,
    'menu-item.scale.error-reading-weight': `خطأ في قراءة الوزن. يرجى المحاولة مرة أخرى.`,
    'menu-item.scale.error-no-weight': `يرجى وزن الصنف إذا كنت ترغب في إضافته إلى طلبك.`,
    'menu-item.scale.no-scale': `لم يتم اكتشاف ميزان. يرجى التواصل مع أحد الموظفين للمساعدة.`,
    'also-consider.title': `قد يعجبك أيضًا...`,
    'also-consider.back-to-item': `العودة إلى الصنف`,
    'also-consider.add-to-order': `إضافة إلى الطلب`,
    'also-consider.skip-add-on': `تخطي الإضافة`,
    'menu-item.assorted.title': `كوّن تشكيلتك`,
    'menu-item.assorted.count': `{{$1: count}} من {{$2: total}} محددة`,
    'menu-item.row-size-mod.option.none': `بدون`,
    'menu-item.high-sugar-warning.description': `تحذير: يشير هذا الرمز إلى أن محتوى السكريات المضافة في هذا الصنف يساوي أو يتجاوز الحد اليومي الموصى به من السكريات المضافة لنظام غذائي بمقدار 2,000 سعرة حرارية (50 g). قد يؤدي تناول أو شرب كميات كبيرة من السكريات المضافة على المدى الطويل إلى زيادة خطر الإصابة بداء السكري من النوع 2 وزيادة الوزن وتسوس الأسنان.`,
    'menu-item.high-sodium-warning.description': `تحذير: يشير هذا الرمز إلى أن محتوى الصوديوم (الملح) في هذا الصنف يتجاوز الحد اليومي الموصى به (2,300 mg). قد يؤدي تناول كميات كبيرة من الصوديوم إلى ارتفاع ضغط الدم وزيادة خطر الإصابة بأمراض القلب والسكتة الدماغية.`,
    'menu-item.group-ordering.items-for': `الطلب الجماعي - الأصناف لـ:`,
    'menu-item.group-ordering.prompt.title': `هل تطلب مع مجموعة؟`,
    'menu-item.group-ordering.prompt.description': `سيسألك خيار الطلب الجماعي عن الشخص الذي يخصه كل صنف من أفراد مجموعتك. اضغط على "نعم" لتفعيل الطلب الجماعي. اضغط على "لا" إذا كنت ترغب في المتابعة بهذا الخيار.`,
    'menu-item.group-ordering.prompt.button.accept': `نعم، طلب جماعي`,
    'menu-item.group-ordering.prompt.button.decline': `لا، شكرًا`,
    'menu-item.group-ordering.add-recipient': `إضافة جديد`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `إضافة مستلم جديد`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `أدخل اسم المستلم`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `إسناد إلى الضيف`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `إلغاء`,
    'menu-item.group-ordering.recipient-picker.title': `لمن هذا الصنف؟`,
    'menu-item.group-ordering.recipient-picker.add-new': `إضافة جديد`,
    'menu-item.nested-mod-groups.edit': `تعديل`,
    'menu-item.nested-mod-groups.popup.done': `تم`,
    'menu-item.nested-mod-groups.popup.cancel': `إلغاء`,
    'menu-item.nested-mod-groups.popup.back': `رجوع`,
    'menu-item.nested-mod-groups.popup.next': `التالي`,
    'checkout.cart.remove-item-verification.title': `مطلوب تحقق من المدير`,
    'checkout.cart.remove-item-verification.description': `يلزم رمز وصول الموظف لإزالة هذا الصنف من السلة. يرجى طلب المساعدة من أحد أفراد الفريق.`,
    'checkout.cart.confirm-remove-item.title': `إزالة الصنف؟`,
    'checkout.cart.confirm-remove-item.description': `هل أنت متأكد أنك تريد إزالة {{$1: item name}} من سلتك؟`,
    'checkout.cart.confirm-remove-item.cancel': `إلغاء`,
    'checkout.cart.confirm-remove-item.confirm': `إزالة`,
    'checkout.cart.pre-checkout-recommendations.title': `أكمل طلبك`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `متابعة`,
    'checkout.cart.pre-checkout-recommendations.back-button': `رجوع`,
    'checkout.cart.item-86d.title.items': `بعض الأصناف لم تعد متوفرة`,
    'checkout.cart.item-86d.title.mods': `بعض التعديلات لم تعد متوفرة`,
    'checkout.cart.item-86d.title.mixed': `بعض الأصناف والتعديلات لم تعد متوفرة`,
    'checkout.cart.item-86d.description.items': `تمت إزالة الأصناف التالية من سلتك:`,
    'checkout.cart.item-86d.description.mods': `تمت إزالة التعديلات التالية من أصنافك:`,
    'checkout.cart.item-86d.description.mixed': `لم تعد العناصر التالية متوفرة وتمت إزالتها:`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}} (في {{$2: item name}})`,
    'checkout.cart.item-86d.edit-item-button': `تعديل`,
    'checkout.payment-options.tip.invalid-tip-amount': `عذرًا، لا يمكنك إضافة إكرامية أكبر من إجمالي الطلب. يرجى إدخال قيمة إكرامية أقل من المجموع الفرعي للطلب بعد خصم أي خصومات.`,
    'checkout.payment-options.name.title': `مرحبًا، {{$1: name}}`,
    'checkout.payment-options.gift-cards.prompt.title': `اختر طريقة بطاقة الهدايا`,
    'checkout.payment-options.gift-cards.prompt.default-option': `بطاقة الهدايا`,
    'checkout.payment-options.pay-with-cash-machine.label': `اضغط للدفع عبر آلة النقد`,
    'checkout.payment-options.pay-with-cash-machine.button': `نقدًا`,
    'checkout.payment-options.donation.or': `أو`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `معلومات رسوم الخدمة`,
    'checkout.payment-options.credit-card.button.zero-balance': `تقديم الطلب`,
    'checkout.payment-options.inline-loyalty.view-all': `عرض جميع المكافآت`,
    'checkout.payment-options.inline-loyalty.apply': `تطبيق المكافآت`,
    'checkout.payment-options.inline-loyalty.greeting': `مرحبًا، {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.star-balance': `رصيد النجوم: {{$1: stars}}\u2605`,
    'checkout.payment-options.inline-loyalty.celebration.title': `عيد ميلاد سعيد!`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `عيد ميلاد سعيد، {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `استمتع بهديتك!`,
    'checkout.payment-options.inline-loyalty.error.title': `تعذّر تطبيق المكافآت`,
    'checkout.payment-options.inline-loyalty.error.message': `حدث خطأ أثناء تطبيق مكافآتك. يرجى المحاولة مرة أخرى.`,
    'loyalty.starbucks.header.redeemable-stars': `النجوم القابلة للاستبدال`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}\u2605 تنتهي في {{$2: date}}`,
    'loyalty.starbucks.header.stars-no-expiry': `لن تنتهي صلاحية نجومك`,
    'loyalty.starbucks.progress.next-status-by-date': `اكسب {{$1: stars}}\u2605 قبل {{$2: date}} للوصول إلى مستوى {{$3: level}}`,
    'loyalty.starbucks.progress.next-status': `اكسب {{$1: stars}}\u2605 للوصول إلى مستوى {{$2: level}}`,
    'loyalty.starbucks.progress.maintain-status-by-date': `اكسب {{$1: stars}}\u2605 قبل {{$2: date}} لتمديد مستواك {{$3: level}} لسنة أخرى`,
    'loyalty.starbucks.progress.maintain-status': `اكسب {{$1: stars}}\u2605 لتمديد مستواك {{$2: level}} لسنة أخرى`,
    'loyalty.starbucks.progress.extended': `تم التمديد لسنة أخرى`,
    'loyalty.starbucks.progress.annual-earned': `المكتسب هذا العام`,
    'loyalty.starbucks.progress.status-target': `مستوى {{$1: level}}`,
    'loyalty.starbucks.progress.to-extend': `للتمديد`,
    'loyalty.starbucks.birthday.title': `عيد ميلاد سعيد، {{$1: name}}!`,
    'loyalty.starbucks.birthday.title-no-name': `عيد ميلاد سعيد!`,
    'loyalty.starbucks.birthday.redeem': `استبدل قسيمة عيد ميلادك!`,
    'loyalty.starbucks.birthday.description': `استمتع بمشروبك أو حلواك المفضلة على حسابنا. استبدلها عند الدفع، أو أخبر الباريستا عند الطلب.`,
    'loyalty.starbucks.birthday.valid-until': `سارية حتى {{$1: date}}`,
    'loyalty.starbucks.member-since': `عضو منذ {{$1: year}}`,
    'loyalty.starbucks.member-since.subtitle': `شكرًا لك على كونك عضوًا وفيًا في Starbucks Rewards.`,
    'checkout.paying.starbucks.title': `يرجى مسح رمز QR في تطبيق Starbucks الآن`,
    'checkout.paying.starbucks.subtitle': `يرجى التأكد من تجهيز خاصية Scan to Pay في تطبيق Starbucks لإتمام طلبك.`,
    'checkout.paying.starbucks.cancel-button': `إلغاء`,
    'checkout.paying.error.loyalty-payment': `عذرًا، لم نتمكن من معالجة دفعتك. يرجى المحاولة مرة أخرى.`,
    'checkout.paying.error.pos.print': `المتابعة وطباعة الإيصال`,
    'checkout.paying.error.table-tracker.print': `المتابعة وطباعة الإيصال`,
    'checkout.paying.error.table-tracker.title': `عذرًا! لم نتمكن من إصدار جهاز التتبع الخاص بك.`,
    'checkout.paying.error.table-tracker.instructions': `تم تنفيذ طلبك، لكن حدث خطأ أثناء إصدار جهاز تتبع الطاولة لمتابعة طلبك. تابع إلى الخطوة التالية لاستلام إيصالك.`,
    'checkout.paying.error.title': `عذرًا!`,
    'checkout.paying.sending-table-tracker-request.title': `جارٍ إصدار جهاز التتبع`,
    'checkout.paying.sending-table-tracker-request.subtitle': `يرجى الانتظار بينما نصدر جهاز تتبع الطاولة الخاص بك.`,
    'checkout.paying.cash-machine.pinging.title': `جارٍ التحقق من آلة النقد`,
    'checkout.paying.cash-machine.pinging.subtitle': `يرجى الانتظار بينما نتحقق من توفر آلة النقد.`,
    'checkout.paying.cash-machine.awaiting.title': `آلة النقد قيد الاستخدام`,
    'checkout.paying.cash-machine.awaiting.subtitle': `يرجى الانتظار حتى تصبح آلة النقد متاحة.`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `إلغاء`,
    'checkout.paying.cash-machine.receiving.title': `آلة النقد جاهزة`,
    'checkout.paying.cash-machine.receiving.subtitle': `يرجى إدخال دفعتك في آلة النقد.`,
    'checkout.paying.cash-machine.receiving.cancel-button': `إلغاء`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `إلغاء واسترداد الدفعة`,
    'checkout.paying.cash-machine.receiving.partial-button': `ادفع الباقي بطريقة أخرى`,
    'checkout.paying.cash-machine.receiving.amount': `{{$1: amount}} متبقٍ`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `يرجى أخذ جميع الأوراق النقدية والعملات المعدنية من آلة النقد.`,
    'checkout.paying.cash-machine.cancelling.title': `جارٍ إلغاء الدفع عبر آلة النقد`,
    'checkout.paying.cash-machine.cancelling.subtitle': `يرجى أخذ جميع الأوراق النقدية والعملات المعدنية من آلة النقد.`,
    'checkout.paying.cash-machine.cancelling.error.title': `خطأ في إلغاء الدفع عبر آلة النقد`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `تعذّر إلغاء دفعتك. يرجى طلب المساعدة من أحد أفراد الفريق.`,
    'checkout.paying.cash-machine.cancelling.error.print': `المتابعة وطباعة الإيصال`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `الفكة غير كافية`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `لم تتمكن آلة النقد من إعطائك الفكة مقابل دفعتك، لذا قمنا باسترداد دفعتك.`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `حاول مرة أخرى`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `رجوع`,
    'checkout.paying.cash-machine.error.message': `لم تتمكن آلة النقد من معالجة دفعتك. يرجى المحاولة مرة أخرى.`,
    'checkout.done.details.guest-name': `الاسم`,
    'checkout.done.details.table-number': `رقم الطاولة`,
    'checkout.done.details.tracker-number': `رقم جهاز التتبع`,
    'checkout.done.details.order-number': `رقم الطلب`,
    'checkout.done.error.table-tracker.instructions': `حدث خطأ أثناء الحصول على جهاز التتبع الخاص بك. تمت معالجة طلبك بنجاح. يرجى طلب المساعدة من أحد الموظفين.`,
    'checkout.done.qr-code.error': `عذرًا، لم نتمكن من إنشاء رمز QR لإيصالك.`,
    'printer-receipt.stored-value-remaining-balance': `الرصيد المتبقي في {{$1: label}}`,
    'printer-receipt.order-ready-at': `سيكون طلبك جاهزًا في {{$1: time}}`,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': `إيصال استرداد`,
    'order-reconciler.error.dining-option-unavailable': `خيار التناول الذي اخترته لم يعد متاحًا. تم تحديث طلبك لاستخدام "{{$1: dining option name}}".`,
    'order-reconciler.error.items-unavailable': `بعض الأصناف في طلبك لم تعد متوفرة. تم تحديث طلبك بإزالة الأصناف غير المتوفرة. الأصناف التي تمت إزالتها: {{$1: item names}}`,
    'page-nav.order-history-item.title': `طلباتك`,
    'page-nav.order-history-item.cta': `عرض طلباتي`,
    'print.error.phone-number-label': `رقم الهاتف`,
    'print.error.guest-name-label': `الاسم`,
    'print.error.table-number-label': `رقم الطاولة`,
    'print.error.tracker-number-label': `رقم جهاز التتبع`,
    'print.error.order-number-label': `رقم الطلب`,
    'debug.untranslated-locale': `إضافة إكرامية`,
};
//# sourceMappingURL=strings.ar-sa.js.map